

<div i18n-dir="@@dir" dir="ltr" i18n-style="@@direction">
  <alert></alert>
  <router-outlet></router-outlet>
</div>
<div style="color: transparent; position: fixed; top: 0; left: 0; z-index: -10;">
<!--  PipeCode -->







































  <span class='languageStringText' i18n='@@lang' id='languageStringTextlang'>lang</span>
  <span class='languageStringText' i18n='@@dir' id='languageStringTextdir'>dir</span>
  <span class='languageStringText' i18n='@@direction' id='languageStringTextdirection'>direction</span>
  <span class='languageStringText' i18n='@@floatEnd' id='languageStringTextfloatEnd'>floatEnd</span>
  <span class='languageStringText' i18n='@@floatStart' id='languageStringTextfloatStart'>floatStart</span>
  <span class='languageStringText' i18n='@@0123456789' id='languageStringText0123456789'>0123456789</span>

  <!-- ════════════════════════════════════════════════════════════════
       UNIT LABELS
       Resolved at runtime by MeasurementUnits (src/app/service-ui/
       measurement-units.ts) via LanguagePipe.get(), which reads this
       block. They are NOT config values - every one of them is display
       text that must be translated. Ids are descriptive rather than the
       English text because "in", "pt" and "em" are ambiguous on their
       own; translate from the VALUE, never the id.
       ═══════════════════════════════════════════════════════════════ -->
  <span class='languageStringText' i18n="unit of length, inches|Abbreviation for inches shown after a measurement, e.g. 8.5 in. Not the English preposition.@@unitLengthInch" id='languageStringTextunitLengthInch'>in</span>
  <span class='languageStringText' i18n="unit of length, millimetres|Abbreviation for millimetres shown after a measurement, e.g. 216 mm.@@unitLengthMillimeter" id='languageStringTextunitLengthMillimeter'>mm</span>
  <span class='languageStringText' i18n="unit of weight, pounds|Abbreviation for pounds shown after a weight, e.g. 0.55 lbs.@@unitWeightPound" id='languageStringTextunitWeightPound'>lbs</span>
  <span class='languageStringText' i18n="unit of weight, kilograms|Abbreviation for kilograms shown after a weight, e.g. 0.25 kg.@@unitWeightKilogram" id='languageStringTextunitWeightKilogram'>kg</span>
  <span class='languageStringText' i18n="unit of volume, cubic inches|Shown after a package volume, e.g. 100 in3 (with a superscript 3).@@unitVolumeCubicInch" id='languageStringTextunitVolumeCubicInch'>in³</span>
  <span class='languageStringText' i18n="unit of volume, cubic centimetres|Shown after a package volume, e.g. 1639 cm3 (with a superscript 3).@@unitVolumeCubicCentimeter" id='languageStringTextunitVolumeCubicCentimeter'>cm³</span>
  <span class='languageStringText' i18n="unit of volume, cubic millimetres|Shown after a package volume, e.g. 16387 mm3 (with a superscript 3).@@unitVolumeCubicMillimeter" id='languageStringTextunitVolumeCubicMillimeter'>mm³</span>
  <span class='languageStringText' i18n="unit of length, typographic points|A point is 1/72 inch. Used by the book layout editors.@@unitLengthPoint" id='languageStringTextunitLengthPoint'>pt</span>
  <span class='languageStringText' i18n="unit of length, screen pixels|CSS pixel unit shown after a margin or padding value in the theme editor.@@unitLengthPixel" id='languageStringTextunitLengthPixel'>px</span>
  <span class='languageStringText' i18n="unit of length, em|CSS em unit shown after a line-height value in the theme editor. Relative to the current font size.@@unitLengthEm" id='languageStringTextunitLengthEm'>em</span>
  <span class='languageStringText' i18n="unit of file size, megabytes|Abbreviation for megabytes shown after an uploaded file size, e.g. 2.40 MB.@@unitFileSizeMegabyte" id='languageStringTextunitFileSizeMegabyte'>MB</span>
























  <span class='languageStringText' i18n='@@100' id='languageStringText100'>100</span>
  <span class='languageStringText' i18n='@@200' id='languageStringText200'>200</span>
  <span class='languageStringText' i18n='@@300' id='languageStringText300'>300</span>
  <span class='languageStringText' i18n='@@400' id='languageStringText400'>400</span>
  <span class='languageStringText' i18n='@@500' id='languageStringText500'>500</span>
  <span class='languageStringText' i18n='@@600' id='languageStringText600'>600</span>
  <span class='languageStringText' i18n='@@700' id='languageStringText700'>700</span>
  <span class='languageStringText' i18n='@@800' id='languageStringText800'>800</span>
  <span class='languageStringText' i18n='@@900' id='languageStringText900'>900</span>


























  <span class='languageStringText' i18n='@@— slot pinned by authored cells; remove all — cells at this position to hide it' id='languageStringText—slotpinnedbyauthoredcells;removeall—cellsatthispositiontohideit'>— slot pinned by authored cells; remove all — cells at this position to hide it</span>




  <span class='languageStringText' i18n='@@# Up' id='languageStringText#Up'># Up</span>

  <span class='languageStringText' i18n='@@%' id='languageStringText%'>%</span>




  <span class='languageStringText' i18n='@@100# Gloss Text' id='languageStringText100#GlossText'>100# Gloss Text</span>
  <span class='languageStringText' i18n='@@100# Gloss Text (Art Book)' id='languageStringText100#GlossText(ArtBook)'>100# Gloss Text (Art Book)</span>
  <span class='languageStringText' i18n='@@100GlossText' id='languageStringText100GlossText'>100# Gloss Text</span>
  <span class='languageStringText' i18n='@@100pt' id='languageStringText100pt'>100pt</span>
  <span class='languageStringText' i18n='@@104pt' id='languageStringText104pt'>104pt</span>
  <span class='languageStringText' i18n='@@108pt' id='languageStringText108pt'>108pt</span>
  <span class='languageStringText' i18n='@@10pt' id='languageStringText10pt'>10pt</span>
  <span class='languageStringText' i18n='@@116pt' id='languageStringText116pt'>116pt</span>
  <span class='languageStringText' i18n='@@11pt' id='languageStringText11pt'>11pt</span>
  <span class='languageStringText' i18n='@@120pt' id='languageStringText120pt'>120pt</span>
  <span class='languageStringText' i18n='@@128pt' id='languageStringText128pt'>128pt</span>
  <span class='languageStringText' i18n='@@12pt' id='languageStringText12pt'>12pt</span>
  <span class='languageStringText' i18n='@@132pt' id='languageStringText132pt'>132pt</span>
  <span class='languageStringText' i18n='@@13pt' id='languageStringText13pt'>13pt</span>
  <span class='languageStringText' i18n='@@140pt' id='languageStringText140pt'>140pt</span>
  <span class='languageStringText' i18n='@@148pt' id='languageStringText148pt'>148pt</span>
  <span class='languageStringText' i18n='@@14pt' id='languageStringText14pt'>14pt</span>
  <span class='languageStringText' i18n='@@156pt' id='languageStringText156pt'>156pt</span>
  <span class='languageStringText' i18n='@@15pt' id='languageStringText15pt'>15pt</span>
  <span class='languageStringText' i18n='@@164pt' id='languageStringText164pt'>164pt</span>
  <span class='languageStringText' i18n='@@16pt' id='languageStringText16pt'>16pt</span>
  <span class='languageStringText' i18n='@@172pt' id='languageStringText172pt'>172pt</span>
  <span class='languageStringText' i18n='@@17pt' id='languageStringText17pt'>17pt</span>
  <span class='languageStringText' i18n='@@180pt' id='languageStringText180pt'>180pt</span>
  <span class='languageStringText' i18n='@@188pt' id='languageStringText188pt'>188pt</span>
  <span class='languageStringText' i18n='@@18pt' id='languageStringText18pt'>18pt</span>
  <span class='languageStringText' i18n='@@196pt' id='languageStringText196pt'>196pt</span>
  <span class='languageStringText' i18n='@@20pt' id='languageStringText20pt'>20pt</span>
  <span class='languageStringText' i18n='@@22pt' id='languageStringText22pt'>22pt</span>
  <span class='languageStringText' i18n='@@240pt' id='languageStringText240pt'>240pt</span>
  <span class='languageStringText' i18n='@@24pt' id='languageStringText24pt'>24pt</span>
  <span class='languageStringText' i18n='@@264pt' id='languageStringText264pt'>264pt</span>
  <span class='languageStringText' i18n='@@26pt' id='languageStringText26pt'>26pt</span>
  <span class='languageStringText' i18n='@@288pt' id='languageStringText288pt'>288pt</span>
  <span class='languageStringText' i18n='@@28pt' id='languageStringText28pt'>28pt</span>
  <span class='languageStringText' i18n='@@3 or 4 digit security code' id='languageStringText3or4digitsecuritycode'>3 or 4 digit security code</span>


  <span class='languageStringText' i18n='@@34pt' id='languageStringText34pt'>34pt</span>
  <span class='languageStringText' i18n='@@36pt' id='languageStringText36pt'>36pt</span>
  <span class='languageStringText' i18n='@@38pt' id='languageStringText38pt'>38pt</span>
  <span class='languageStringText' i18n='@@4 Books' id='languageStringText4Books'>4 Books</span>
  <span class='languageStringText' i18n='@@40# White' id='languageStringText40#White'>40# White</span>
  <span class='languageStringText' i18n='@@40pt' id='languageStringText40pt'>40pt</span>
  <span class='languageStringText' i18n='@@42pt' id='languageStringText42pt'>42pt</span>
  <span class='languageStringText' i18n='@@44pt' id='languageStringText44pt'>44pt</span>
  <span class='languageStringText' i18n='@@46pt' id='languageStringText46pt'>46pt</span>
  <span class='languageStringText' i18n='@@48pt' id='languageStringText48pt'>48pt</span>
  <span class='languageStringText' i18n='@@4in Boxes' id='languageStringText4inBoxes'>4in Boxes</span>
  <span class='languageStringText' i18n='@@5.0inX7.0in' id='languageStringText5.0inX7.0in'>5.0inX7.0in</span>
  <span class='languageStringText' i18n='@@5.5in X 8.5in' id='languageStringText5.5inX8.5in'>5.5in X 8.5in</span>
  <span class='languageStringText' i18n='@@50pt' id='languageStringText50pt'>50pt</span>
  <span class='languageStringText' i18n='@@52pt' id='languageStringText52pt'>52pt</span>
  <span class='languageStringText' i18n='@@54pt' id='languageStringText54pt'>54pt</span>
  <span class='languageStringText' i18n='@@56pt' id='languageStringText56pt'>56pt</span>
  <span class='languageStringText' i18n='@@58pt' id='languageStringText58pt'>58pt</span>
  <span class='languageStringText' i18n='@@6.0inX9.0in' id='languageStringText6.0inX9.0in'>6.0inX9.0in</span>
  <span class='languageStringText' i18n='@@60#' id='languageStringText60#'>60#</span>
  <span class='languageStringText' i18n='@@60# White' id='languageStringText60#White'>60# White</span>
  <span class='languageStringText' i18n='@@60pt' id='languageStringText60pt'>60pt</span>
  <span class='languageStringText' i18n='@@64pt' id='languageStringText64pt'>64pt</span>
  <span class='languageStringText' i18n='@@68pt' id='languageStringText68pt'>68pt</span>
  <span class='languageStringText' i18n='@@6pt' id='languageStringText6pt'>6pt</span>
  <span class='languageStringText' i18n='@@72pt' id='languageStringText72pt'>72pt</span>
  <span class='languageStringText' i18n='@@76pt' id='languageStringText76pt'>76pt</span>
  <span class='languageStringText' i18n='@@7pt' id='languageStringText7pt'>7pt</span>
  <span class='languageStringText' i18n='@@8.5inX11.0in' id='languageStringText8.5inX11.0in'>8.5inX11.0in</span>
  <span class='languageStringText' i18n='@@80# Gloss Text' id='languageStringText80#GlossText'>80# Gloss Text</span>
  <span class='languageStringText' i18n='@@80# Matte Text' id='languageStringText80#MatteText'>80# Matte Text</span>
  <span class='languageStringText' i18n='@@80GlossText' id='languageStringText80GlossText'>80GlossText</span>
  <span class='languageStringText' i18n='@@80MatteText' id='languageStringText80MatteText'>80MatteText</span>
  <span class='languageStringText' i18n='@@80pt' id='languageStringText80pt'>80pt</span>
  <span class='languageStringText' i18n='@@84pt' id='languageStringText84pt'>84pt</span>
  <span class='languageStringText' i18n='@@88pt' id='languageStringText88pt'>88pt</span>
  <span class='languageStringText' i18n='@@8pt' id='languageStringText8pt'>8pt</span>
  <span class='languageStringText' i18n='@@92pt' id='languageStringText92pt'>92pt</span>
  <span class='languageStringText' i18n='@@96pt' id='languageStringText96pt'>96pt</span>
  <span class='languageStringText' i18n='@@9pt' id='languageStringText9pt'>9pt</span>




  <span class='languageStringText' i18n='@@business day' id='languageStringTextbusinessday'>business day</span>
  <span class='languageStringText' i18n='@@business days' id='languageStringTextbusinessdays'>business days</span>
  <span class='languageStringText' i18n='@@CollectionProvider not found or you do not have permission to view it.' id='languageStringTextCollectionProvidernotfoundoryoudonothavepermissiontoviewit.'>CollectionProvider not found or you do not have permission to view it.</span>
  <span class='languageStringText' i18n='@@Could not load your ServiceProvider record.' id='languageStringTextCouldnotloadyourServiceProviderrecord.'>Could not load your ServiceProvider record.</span>
  <span class='languageStringText' i18n='@@Could not save preference' id='languageStringTextCouldnotsavepreference'>Could not save preference</span>
  <span class='languageStringText' i18n='@@Could not save the credit card' id='languageStringTextCouldnotsavethecreditcard'>Could not save the credit card</span>
  <span class='languageStringText' i18n='@@Could not start the Shopify install. Please verify the shop handle and try again.' id='languageStringTextCouldnotstarttheShopifyinstall.Pleaseverifytheshophandleandtryagain.'>Could not start the Shopify install. Please verify the shop handle and try again.</span>
  <span class='languageStringText' i18n='@@Credit card' id='languageStringTextCreditcard'>Credit card</span>
  <span class='languageStringText' i18n='@@day' id='languageStringTextday'>day</span>
  <span class='languageStringText' i18n='@@Delivery time not available' id='languageStringTextDeliverytimenotavailable'>Delivery time not available</span>
  <span class='languageStringText' i18n='@@Duplicate setting key:' id='languageStringTextDuplicatesettingkey:'>Duplicate setting key:</span>
  <span class='languageStringText' i18n='@@Failed to load CollectionProvider.' id='languageStringTextFailedtoloadCollectionProvider.'>Failed to load CollectionProvider.</span>
  <span class='languageStringText' i18n='@@Finalize' id='languageStringTextFinalize'>Finalize</span>
  <span class='languageStringText' i18n='@@No estimate' id='languageStringTextNoestimate'>No estimate</span>
  <span class='languageStringText' i18n='@@Per book' id='languageStringTextPerbook'>Per book</span>
  <span class='languageStringText' i18n='@@Per page' id='languageStringTextPerpage'>Per page</span>
  <span class='languageStringText' i18n='@@Save failed. Please try again.' id='languageStringTextSavefailed.Pleasetryagain.'>Save failed. Please try again.</span>
  <span class='languageStringText' i18n='@@Shopify did not return an authorize URL. Please try again.' id='languageStringTextShopifydidnotreturnanauthorizeURL.Pleasetryagain.'>Shopify did not return an authorize URL. Please try again.</span>






















































































  <span class='languageStringText' i18n='@@COMPLETE' id='languageStringTextCOMPLETE'>Complete</span>
  <span class='languageStringText' i18n='@@Smooth Opaque' id='languageStringTextSmoothOpaque'>Smooth Opaque</span>












































































































  <span class='languageStringText' i18n='@@Failed to create shipping labels for order' id='languageStringTextFailedtocreateshippinglabelsfororder'>Failed to create shipping labels for order</span>
  <span class='languageStringText' i18n='@@Shipping labels queued for printing' id='languageStringTextShippinglabelsqueuedforprinting'>Shipping labels queued for printing</span>
  <span class='languageStringText' i18n='@@Shipping labels: N of M packages failed' id='languageStringTextShippinglabels:NofMpackagesfailed'>Shipping labels: N of M packages failed</span>
  <span class='languageStringText' i18n='@@Your order is being placed. You can watch the Orders page for updates.' id='languageStringTextYourorderisbeingplaced.YoucanwatchtheOrderspageforupdates.'>Your order is being placed. You can watch the Orders page for updates.</span>
  <span class='languageStringText' i18n='@@Prices changed - please review and resubmit.' id='languageStringTextPriceschanged-pleasereviewandresubmit.'>Prices changed - please review and resubmit.</span>




















  <span class='languageStringText' i18n='@@ACCEPTED' id='languageStringTextACCEPTED'>Accepted</span>













  <span class='languageStringText' i18n='@@active' id='languageStringTextactive'>active</span>
  <span class='languageStringText' i18n='@@Active' id='languageStringTextActive'>Active</span>

























































  <span class='languageStringText' i18n='@@address' id='languageStringTextaddress'>address</span>

  <span class='languageStringText' i18n='@@Address 1' id='languageStringTextAddress1'>Address 1</span>



  <span class='languageStringText' i18n='@@Address Error' id='languageStringTextAddressError'>Address Error</span>
  <span class='languageStringText' i18n='@@Address Is Not Valid For The Selected Shipping' id='languageStringTextAddressIsNotValidForTheSelectedShipping'>Address Is Not Valid For The Selected Shipping</span>




  <span class='languageStringText' i18n='@@Address1' id='languageStringTextAddress1'>Address Line 1</span>
  <span class='languageStringText' i18n='@@Address2' id='languageStringTextAddress2'>Address Line 2</span>


  <span class='languageStringText' i18n='@@AddressStatusPrefix' id='languageStringTextAddressStatusPrefix'>AddressStatusPrefix</span>










  <span class='languageStringText' i18n='@@Admin' id='languageStringTextAdmin'>Admin</span>
  <span class='languageStringText' i18n='@@Admin Organization' id='languageStringTextAdminOrganization'>Admin Organization</span>
  <span class='languageStringText' i18n='@@Admin Organization Id' id='languageStringTextAdminOrganizationId'>Admin Organization Id</span>



  <span class='languageStringText' i18n='@@AdventPro' id='languageStringTextAdventPro'>AdventPro</span>


  <span class='languageStringText' i18n='@@Alegreya' id='languageStringTextAlegreya'>Alegreya</span>

  <span class='languageStringText' i18n='@@all' id='languageStringTextall'>all</span>

  <span class='languageStringText' i18n='@@All Data Fields Are Mapped.' id='languageStringTextAllDataFieldsAreMapped.'>All Data Fields Are Mapped.</span>






  <span class='languageStringText' i18n='@@always' id='languageStringTextalways'>always</span>
















  <span class='languageStringText' i18n='@@API' id='languageStringTextAPI'>API</span>





  <span class='languageStringText' i18n='@@Approved' id='languageStringTextApproved'>Approved</span>






  <span class='languageStringText' i18n='@@Arial' id='languageStringTextArial'>Arial</span>
  <span class='languageStringText' i18n='@@Arimo' id='languageStringTextArimo'>Arimo</span>
  <span class='languageStringText' i18n='@@Armata' id='languageStringTextArmata'>Armata</span>

  <span class='languageStringText' i18n='@@armenian' id='languageStringTextarmenian'>armenian</span>


  <span class='languageStringText' i18n='@@Assigned to' id='languageStringTextAssignedto'>Assigned to</span>







  <span class='languageStringText' i18n='@@author' id='languageStringTextauthor'>author</span>
  <span class='languageStringText' i18n='@@Author' id='languageStringTextAuthor'>Author</span>
  <span class='languageStringText' i18n='@@author2' id='languageStringTextauthor2'>author2</span>
  <span class='languageStringText' i18n='@@author3' id='languageStringTextauthor3'>author3</span>

  <span class='languageStringText' i18n='@@auto' id='languageStringTextauto'>auto</span>



  <span class='languageStringText' i18n='@@avoid' id='languageStringTextavoid'>avoid</span>


  <span class='languageStringText' i18n='@@B' id='languageStringTextB'>B</span>

  <span class='languageStringText' i18n='@@Back' id='languageStringTextBack'>Back</span>



  <span class='languageStringText' i18n='@@back-address' id='languageStringTextback-address'>back-address</span>
  <span class='languageStringText' i18n='@@back-author-1' id='languageStringTextback-author-1'>back-author-1</span>
  <span class='languageStringText' i18n='@@back-author-2' id='languageStringTextback-author-2'>back-author-2</span>
  <span class='languageStringText' i18n='@@back-author-picture' id='languageStringTextback-author-picture'>back-author-picture</span>
  <span class='languageStringText' i18n='@@back-background' id='languageStringTextback-background'>back-background</span>
  <span class='languageStringText' i18n='@@back-background-2' id='languageStringTextback-background-2'>back-background-2</span>
  <span class='languageStringText' i18n='@@back-background-image' id='languageStringTextback-background-image'>back-background-image</span>
  <span class='languageStringText' i18n='@@back-barcode' id='languageStringTextback-barcode'>back-barcode</span>
  <span class='languageStringText' i18n='@@back-category' id='languageStringTextback-category'>back-category</span>
  <span class='languageStringText' i18n='@@back-edition' id='languageStringTextback-edition'>back-edition</span>
  <span class='languageStringText' i18n='@@back-heading-1' id='languageStringTextback-heading-1'>back-heading-1</span>
  <span class='languageStringText' i18n='@@back-heading-2' id='languageStringTextback-heading-2'>back-heading-2</span>
  <span class='languageStringText' i18n='@@back-heading-3' id='languageStringTextback-heading-3'>back-heading-3</span>
  <span class='languageStringText' i18n='@@back-heading-4' id='languageStringTextback-heading-4'>back-heading-4</span>
  <span class='languageStringText' i18n='@@back-heading-5' id='languageStringTextback-heading-5'>back-heading-5</span>
  <span class='languageStringText' i18n='@@back-heading-6' id='languageStringTextback-heading-6'>back-heading-6</span>
  <span class='languageStringText' i18n='@@back-image-1' id='languageStringTextback-image-1'>back-image-1</span>
  <span class='languageStringText' i18n='@@back-image-2' id='languageStringTextback-image-2'>back-image-2</span>
  <span class='languageStringText' i18n='@@back-ISBN' id='languageStringTextback-ISBN'>back-ISBN</span>
  <span class='languageStringText' i18n='@@back-line-1' id='languageStringTextback-line-1'>back-line-1</span>
  <span class='languageStringText' i18n='@@back-line-2' id='languageStringTextback-line-2'>back-line-2</span>
  <span class='languageStringText' i18n='@@back-line-3' id='languageStringTextback-line-3'>back-line-3</span>
  <span class='languageStringText' i18n='@@back-line-4' id='languageStringTextback-line-4'>back-line-4</span>
  <span class='languageStringText' i18n='@@back-phone' id='languageStringTextback-phone'>back-phone</span>

  <span class='languageStringText' i18n='@@back-price' id='languageStringTextback-price'>back-price</span>
  <span class='languageStringText' i18n='@@back-publisher-logo-1' id='languageStringTextback-publisher-logo-1'>back-publisher-logo-1</span>
  <span class='languageStringText' i18n='@@back-publisher-logo-2' id='languageStringTextback-publisher-logo-2'>back-publisher-logo-2</span>
  <span class='languageStringText' i18n='@@back-rectangle-1' id='languageStringTextback-rectangle-1'>back-rectangle-1</span>
  <span class='languageStringText' i18n='@@back-rectangle-2' id='languageStringTextback-rectangle-2'>back-rectangle-2</span>
  <span class='languageStringText' i18n='@@back-rectangle-3' id='languageStringTextback-rectangle-3'>back-rectangle-3</span>
  <span class='languageStringText' i18n='@@back-rectangle-4' id='languageStringTextback-rectangle-4'>back-rectangle-4</span>
  <span class='languageStringText' i18n='@@back-rectangle-5' id='languageStringTextback-rectangle-5'>back-rectangle-5</span>
  <span class='languageStringText' i18n='@@back-rectangle-6' id='languageStringTextback-rectangle-6'>back-rectangle-6</span>
  <span class='languageStringText' i18n='@@back-series' id='languageStringTextback-series'>back-series</span>
  <span class='languageStringText' i18n='@@back-tag-line-1' id='languageStringTextback-tag-line-1'>back-tag-line-1</span>
  <span class='languageStringText' i18n='@@back-tag-line-2' id='languageStringTextback-tag-line-2'>back-tag-line-2</span>
  <span class='languageStringText' i18n='@@back-text-1' id='languageStringTextback-text-1'>back-text-1</span>
  <span class='languageStringText' i18n='@@back-text-2' id='languageStringTextback-text-2'>back-text-2</span>
  <span class='languageStringText' i18n='@@back-text-3' id='languageStringTextback-text-3'>back-text-3</span>
  <span class='languageStringText' i18n='@@back-text-4' id='languageStringTextback-text-4'>back-text-4</span>
  <span class='languageStringText' i18n='@@back-text-5' id='languageStringTextback-text-5'>back-text-5</span>
  <span class='languageStringText' i18n='@@back-text-6' id='languageStringTextback-text-6'>back-text-6</span>
  <span class='languageStringText' i18n='@@back-title-1' id='languageStringTextback-title-1'>back-title-1</span>
  <span class='languageStringText' i18n='@@back-title-2' id='languageStringTextback-title-2'>back-title-2</span>
  <span class='languageStringText' i18n='@@back-title-3' id='languageStringTextback-title-3'>back-title-3</span>
  <span class='languageStringText' i18n='@@back-title-4' id='languageStringTextback-title-4'>back-title-4</span>
  <span class='languageStringText' i18n='@@back-transparent-image' id='languageStringTextback-transparent-image'>back-transparent-image</span>
  <span class='languageStringText' i18n='@@back-volume' id='languageStringTextback-volume'>back-volume</span>
  <span class='languageStringText' i18n='@@back1' id='languageStringTextback1'>back1</span>
  <span class='languageStringText' i18n='@@back2' id='languageStringTextback2'>back2</span>
  <span class='languageStringText' i18n='@@back3' id='languageStringTextback3'>back3</span>
  <span class='languageStringText' i18n='@@back4' id='languageStringTextback4'>back4</span>
  <span class='languageStringText' i18n='@@backBack' id='languageStringTextbackBack'>backBack</span>
  <span class='languageStringText' i18n='@@backBack2' id='languageStringTextbackBack2'>backBack2</span>
  <span class='languageStringText' i18n='@@backBack3' id='languageStringTextbackBack3'>backBack3</span>
  <span class='languageStringText' i18n='@@backBody' id='languageStringTextbackBody'>backBody</span>



  <span class='languageStringText' i18n='@@backLeft' id='languageStringTextbackLeft'>backLeft</span>
  <span class='languageStringText' i18n='@@backLine' id='languageStringTextbackLine'>backLine</span>
  <span class='languageStringText' i18n='@@backMainTitle' id='languageStringTextbackMainTitle'>backMainTitle</span>
  <span class='languageStringText' i18n='@@backMainTitle1' id='languageStringTextbackMainTitle1'>backMainTitle1</span>
  <span class='languageStringText' i18n='@@backMainTitle2' id='languageStringTextbackMainTitle2'>backMainTitle2</span>
  <span class='languageStringText' i18n='@@backRight' id='languageStringTextbackRight'>backRight</span>
  <span class='languageStringText' i18n='@@backTop' id='languageStringTextbackTop'>backTop</span>

















  <span class='languageStringText' i18n='@@Bind' id='languageStringTextBind'>Bind</span>
  <span class='languageStringText' i18n='@@Binding' id='languageStringTextBinding'>Binding</span>
  <span class='languageStringText' i18n='@@Binding Type' id='languageStringTextBindingType'>Binding Type</span>







  <span class='languageStringText' i18n='@@body' id='languageStringTextbody'>body</span>






  <span class='languageStringText' i18n='@@Body Resource ID' id='languageStringTextBodyResourceID'>Body Resource Id</span>










  <span class='languageStringText' i18n='@@BodyPrint' id='languageStringTextBodyPrint'>Body Print</span>
  <span class='languageStringText' i18n='@@Bold' id='languageStringTextBold'>Bold</span>

  <span class='languageStringText' i18n='@@Bolder' id='languageStringTextBolder'>Bolder</span>


  <span class='languageStringText' i18n='@@Boogaloo' id='languageStringTextBoogaloo'>Boogaloo</span>
  <span class='languageStringText' i18n='@@book' id='languageStringTextbook'>book</span>
  <span class='languageStringText' i18n='@@Book' id='languageStringTextBook'>Book</span>
  <span class='languageStringText' i18n='@@Book ID' id='languageStringTextBookID'>Book Id</span>
  <span class='languageStringText' i18n='@@Book Id' id='languageStringTextBookId'>Book Id</span>







  <span class='languageStringText' i18n='@@BookID' id='languageStringTextBookID'>BookID</span>
  <span class='languageStringText' i18n='@@BookId' id='languageStringTextBookId'>Book Id</span>
  <span class='languageStringText' i18n='@@books' id='languageStringTextbooks'>books</span>


  <span class='languageStringText' i18n='@@BookTitle' id='languageStringTextBookTitle'>Book Title</span>





  <span class='languageStringText' i18n='@@Bottom' id='languageStringTextBottom'>Bottom</span>
















  <span class='languageStringText' i18n='@@CabinCondensed' id='languageStringTextCabinCondensed'>CabinCondensed</span>
  <span class='languageStringText' i18n='@@Cagliostro' id='languageStringTextCagliostro'>Cagliostro</span>
  <span class='languageStringText' i18n='@@CALENDAR' id='languageStringTextCALENDAR'>Calendar</span>
























  <span class='languageStringText' i18n='@@Cantarell' id='languageStringTextCantarell'>Cantarell</span>

  <span class='languageStringText' i18n='@@Capriola' id='languageStringTextCapriola'>Capriola</span>
  <span class='languageStringText' i18n='@@Carrier' id='languageStringTextCarrier'>Carrier</span>




  <span class='languageStringText' i18n='@@Carrier Service Level Status' id='languageStringTextCarrierServiceLevelStatus'>Carrier Service Level Status</span>

  <span class='languageStringText' i18n='@@CarrierServiceLevelStatusPrefix' id='languageStringTextCarrierServiceLevelStatusPrefix'>CarrierServiceLevelStatusPrefix</span>



  <span class='languageStringText' i18n='@@Case Quantity' id='languageStringTextCaseQuantity'>Case Quantity</span>
  <span class='languageStringText' i18n='@@Catalog' id='languageStringTextCatalog'>Catalog</span>




  <span class='languageStringText' i18n='@@center' id='languageStringTextcenter'>center</span>

  <span class='languageStringText' i18n='@@Centered' id='languageStringTextCentered'>Centered</span>



  <span class='languageStringText' i18n='@@Certificate upload failed. Please try again.' id='languageStringTextCertificateuploadfailed.Pleasetryagain.'>Certificate upload failed. Please try again.</span>


















  <span class='languageStringText' i18n='@@ChapterBlockQuote' id='languageStringTextChapterBlockQuote'>ChapterBlockQuote</span>
  <span class='languageStringText' i18n='@@ChapterEmphasis' id='languageStringTextChapterEmphasis'>ChapterEmphasis</span>
  <span class='languageStringText' i18n='@@ChapterFirstParagraph' id='languageStringTextChapterFirstParagraph'>ChapterFirstParagraph</span>
  <span class='languageStringText' i18n='@@ChapterHeading1' id='languageStringTextChapterHeading1'>ChapterHeading1</span>
  <span class='languageStringText' i18n='@@ChapterHeading2' id='languageStringTextChapterHeading2'>ChapterHeading2</span>
  <span class='languageStringText' i18n='@@ChapterHeading3' id='languageStringTextChapterHeading3'>ChapterHeading3</span>
  <span class='languageStringText' i18n='@@ChapterHorizontalRule' id='languageStringTextChapterHorizontalRule'>ChapterHorizontalRule</span>
  <span class='languageStringText' i18n='@@ChapterImage' id='languageStringTextChapterImage'>ChapterImage</span>
  <span class='languageStringText' i18n='@@ChapterIndent1' id='languageStringTextChapterIndent1'>ChapterIndent1</span>
  <span class='languageStringText' i18n='@@ChapterIndent2' id='languageStringTextChapterIndent2'>ChapterIndent2</span>
  <span class='languageStringText' i18n='@@ChapterIndent3' id='languageStringTextChapterIndent3'>ChapterIndent3</span>
  <span class='languageStringText' i18n='@@ChapterList' id='languageStringTextChapterList'>ChapterList</span>
  <span class='languageStringText' i18n='@@ChapterParagraph' id='languageStringTextChapterParagraph'>ChapterParagraph</span>
  <span class='languageStringText' i18n='@@ChapterPoetry' id='languageStringTextChapterPoetry'>ChapterPoetry</span>

  <span class='languageStringText' i18n='@@ChapterStrong' id='languageStringTextChapterStrong'>ChapterStrong</span>





  <span class='languageStringText' i18n='@@chargeProfile' id='languageStringTextchargeProfile'>Charge Profile</span>






  <span class='languageStringText' i18n='@@Checkout' id='languageStringTextCheckout'>Checkout</span>
  <span class='languageStringText' i18n='@@CherryCreamSoda' id='languageStringTextCherryCreamSoda'>CherryCreamSoda</span>







  <span class='languageStringText' i18n='@@circle' id='languageStringTextcircle'>circle</span>
  <span class='languageStringText' i18n='@@City' id='languageStringTextCity'>City</span>
  <span class='languageStringText' i18n='@@cjk-ideographic' id='languageStringTextcjk-ideographic'>cjk-ideographic</span>
  <span class='languageStringText' i18n='@@Classic' id='languageStringTextClassic'>Classic</span>
  <span class='languageStringText' i18n='@@Click to request preparation' id='languageStringTextClicktorequestpreparation'>Click to request preparation</span>
  <span class='languageStringText' i18n='@@Click to request standardization' id='languageStringTextClicktorequeststandardization'>Click to request standardization</span>













  <span class='languageStringText' i18n='@@CLOSED' id='languageStringTextCLOSED'>Closed</span>



  <span class='languageStringText' i18n='@@COIL' id='languageStringTextCOIL'>Coil</span>
  <span class='languageStringText' i18n='@@Coil' id='languageStringTextCoil'>Coil</span>


  <span class='languageStringText' i18n='@@Collapse this characteristic (treat all its values the same in this group)' id='languageStringTextCollapsethischaracteristic(treatallitsvaluesthesameinthisgroup)'>Collapse this characteristic (treat all its values the same in this group)</span>

  <span class='languageStringText' i18n='@@COLOR' id='languageStringTextCOLOR'>Color</span>







  <span class='languageStringText' i18n='@@Comfortaa' id='languageStringTextComfortaa'>Comfortaa</span>







  <span class='languageStringText' i18n='@@Company' id='languageStringTextCompany'>Company</span>



  <span class='languageStringText' i18n='@@Complete' id='languageStringTextComplete'>Complete</span>




  <span class='languageStringText' i18n='@@ConcertOne' id='languageStringTextConcertOne'>ConcertOne</span>






























  <span class='languageStringText' i18n='@@Convergence' id='languageStringTextConvergence'>Convergence</span>

  <span class='languageStringText' i18n='@@Convert the wildcard row to the collapsed (—) row' id='languageStringTextConvertthewildcardrowtothecollapsed(—)row'>Convert the wildcard row to the collapsed (—) row</span>
  <span class='languageStringText' i18n='@@Convert these cells back to the wildcard (*) row' id='languageStringTextConvertthesecellsbacktothewildcard(*)row'>Convert these cells back to the wildcard (*) row</span>







  <span class='languageStringText' i18n='@@CopyrightEmphasis' id='languageStringTextCopyrightEmphasis'>CopyrightEmphasis</span>
  <span class='languageStringText' i18n='@@CopyrightH1' id='languageStringTextCopyrightH1'>CopyrightH1</span>
  <span class='languageStringText' i18n='@@copyrightPage' id='languageStringTextcopyrightPage'>copyrightPage</span>
  <span class='languageStringText' i18n='@@CopyrightParagraph' id='languageStringTextCopyrightParagraph'>CopyrightParagraph</span>
  <span class='languageStringText' i18n='@@CopyrightStrong' id='languageStringTextCopyrightStrong'>CopyrightStrong</span>


  <span class='languageStringText' i18n='what we pay|Internal cost to produce or ship the item. Not the customer-facing Price. Confusing the two misreports margin.@@Cost' id='languageStringTextCost'>Cost</span>
  <span class='languageStringText' i18n='@@cost' id='languageStringTextcost'>cost</span>


  <span class='languageStringText' i18n='@@Cost Of Production Exceeds The Threshold Relative To Revenue' id='languageStringTextCostOfProductionExceedsTheThresholdRelativeToRevenue'>Cost Of Production Exceeds The Threshold Relative To Revenue</span>




  <span class='languageStringText' i18n='@@Could not save package changes. Please try again.' id='languageStringTextCouldnotsavepackagechanges.Pleasetryagain.'>Could not save package changes. Please try again.</span>
  <span class='languageStringText' i18n='@@Could not save split. Please try again.' id='languageStringTextCouldnotsavesplit.Pleasetryagain.'>Could not save split. Please try again.</span>
  <span class='languageStringText' i18n='@@Country' id='languageStringTextCountry'>Country</span>

  <span class='languageStringText' i18n='@@cover' id='languageStringTextcover'>cover</span>








  <span class='languageStringText' i18n='@@Cover Resource ID' id='languageStringTextCoverResourceID'>Cover Resource Id</span>

















  <span class='languageStringText' i18n='@@CoverPrint' id='languageStringTextCoverPrint'>Cover Print</span>





















  <span class='languageStringText' i18n='@@Created' id='languageStringTextCreated'>Created</span>



  <span class='languageStringText' i18n='@@Creme' id='languageStringTextCreme'>Creme</span>
  <span class='languageStringText' i18n='@@CreteRound' id='languageStringTextCreteRound'>CreteRound</span>
  <span class='languageStringText' i18n='@@Crimson' id='languageStringTextCrimson'>Crimson</span>

  <span class='languageStringText' i18n='@@CSV' id='languageStringTextCSV'>CSV</span>





  <span class='languageStringText' i18n='@@Cumulative Pages' id='languageStringTextCumulativePages'>Cumulative Pages</span>






  <span class='languageStringText' i18n='@@current ∞' id='languageStringTextcurrent∞'>current ∞</span>













  <span class='languageStringText' i18n='@@Customer Order Id' id='languageStringTextCustomerOrderId'>Customer Order Id</span>








  <span class='languageStringText' i18n='@@CutApart' id='languageStringTextCutApart'>Cut Apart</span>



  <span class='languageStringText' i18n='@@D&L' id='languageStringTextD&L'>D&L</span>
  <span class='languageStringText' i18n='@@D&L Inventory' id='languageStringTextD&LInventory'>D&L Inventory</span>
  <span class='languageStringText' i18n='@@D&L Singles' id='languageStringTextD&LSingles'>D&L Singles</span>


  <span class='languageStringText' i18n='@@Data Id' id='languageStringTextDataId'>Data Id</span>

  <span class='languageStringText' i18n='@@Data Type' id='languageStringTextDataType'>Data Type</span>


  <span class='languageStringText' i18n='@@days' id='languageStringTextdays'>days</span>


  <span class='languageStringText' i18n='@@decimal' id='languageStringTextdecimal'>decimal</span>
  <span class='languageStringText' i18n='@@decimal-leading-zero' id='languageStringTextdecimal-leading-zero'>decimal-leading-zero</span>





  <span class='languageStringText' i18n='@@Decreased by' id='languageStringTextDecreasedby'>Decreased by</span>
  <span class='languageStringText' i18n='@@DeeplyNestedBullets' id='languageStringTextDeeplyNestedBullets'>DeeplyNestedBullets</span>












  <span class='languageStringText' i18n='@@DefaultChapterContent' id='languageStringTextDefaultChapterContent'>DefaultChapterContent</span>

  <span class='languageStringText' i18n='@@DefaultCopyrightPageContent' id='languageStringTextDefaultCopyrightPageContent'>DefaultCopyrightPageContent</span>


  <span class='languageStringText' i18n='@@DefaultTableofContent' id='languageStringTextDefaultTableofContent'>DefaultTableofContent</span>
  <span class='languageStringText' i18n='@@DefaultText' id='languageStringTextDefaultText'>DefaultText</span>
  <span class='languageStringText' i18n='@@DefaultTitlePageContent' id='languageStringTextDefaultTitlePageContent'>DefaultTitlePageContent</span>
  <span class='languageStringText' i18n='@@DefaultTitlePageTitle' id='languageStringTextDefaultTitlePageTitle'>DefaultTitlePageTitle</span>
  <span class='languageStringText' i18n='@@DefaultTOCContent' id='languageStringTextDefaultTOCContent'>DefaultTOCContent</span>

  <span class='languageStringText' i18n='destructive removal|Button that permanently destroys the record. Must be clearly different from Cancel, which only closes a dialog.@@Delete' id='languageStringTextDelete'>Delete</span>
















  <span class='languageStringText' i18n='@@Denied' id='languageStringTextDenied'>Denied</span>











































  <span class='languageStringText' i18n='@@DISABLE USER' id='languageStringTextDISABLEUSER'>DISABLE USER</span>
  <span class='languageStringText' i18n='@@disc' id='languageStringTextdisc'>disc</span>




  <span class='languageStringText' i18n='@@DL' id='languageStringTextDL'>DL</span>
  <span class='languageStringText' i18n='@@DL Singles' id='languageStringTextDLSingles'>DL Singles</span>







  <span class='languageStringText' i18n='@@DoppioOne' id='languageStringTextDoppioOne'>DoppioOne</span>


















  <span class='languageStringText' i18n='@@DRAFT' id='languageStringTextDRAFT'>Draft</span>

  <span class='languageStringText' i18n='@@draft' id='languageStringTextdraft'>draft</span>



  <span class='languageStringText' i18n='@@drafts' id='languageStringTextdrafts'>drafts</span>
  <span class='languageStringText' i18n='@@Drafts' id='languageStringTextDrafts'>Drafts</span>
  <span class='languageStringText' i18n='@@DraftsToolTip' id='languageStringTextDraftsToolTip'>Drafts you are still working on</span>







  <span class='languageStringText' i18n='@@Due Date' id='languageStringTextDueDate'>Due Date</span>



  <span class='languageStringText' i18n='@@Easy' id='languageStringTextEasy'>Easy</span>





  <span class='languageStringText' i18n='@@Ecommerce Order Id' id='languageStringTextEcommerceOrderId'>Ecommerce Order Id</span>






  <span class='languageStringText' i18n='@@ecommerceConnection' id='languageStringTextecommerceConnection'>Ecommerce Connection</span>

  <span class='languageStringText' i18n='@@ecommerceOrder' id='languageStringTextecommerceOrder'>Ecommerce Order</span>

  <span class='languageStringText' i18n='@@ecommerceProduct' id='languageStringTextecommerceProduct'>Ecommerce Product</span>































  <span class='languageStringText' i18n='@@EkMukta' id='languageStringTextEkMukta'>EkMukta</span>

  <span class='languageStringText' i18n='@@Elegant' id='languageStringTextElegant'>Elegant</span>
  <span class='languageStringText' i18n='@@Email' id='languageStringTextEmail'>Email</span>




  <span class='languageStringText' i18n='@@Emphasis' id='languageStringTextEmphasis'>Emphasis</span>




  <span class='languageStringText' i18n='@@ENABLE USER' id='languageStringTextENABLEUSER'>ENABLE USER</span>

  <span class='languageStringText' i18n='@@Engagement' id='languageStringTextEngagement'>Engagement</span>

  <span class='languageStringText' i18n='@@Enter delivery address first' id='languageStringTextEnterdeliveryaddressfirst'>Enter delivery address first</span>




  <span class='languageStringText' i18n='@@Error' id='languageStringTextError'>Error</span>
  <span class='languageStringText' i18n='@@ERROR' id='languageStringTextERROR'>Error</span>


  <span class='languageStringText' i18n='@@Error Releasing To Production' id='languageStringTextErrorReleasingToProduction'>Error Releasing To Production</span>
  <span class='languageStringText' i18n='@@ErrorRemoteOrderID' id='languageStringTextErrorRemoteOrderID'>ErrorRemoteOrderID</span>



  <span class='languageStringText' i18n='@@excludes pending charges' id='languageStringTextexcludespendingcharges'>excludes pending charges</span>








  <span class='languageStringText' i18n='@@Expand this characteristic (let it differentiate cells)' id='languageStringTextExpandthischaracteristic(letitdifferentiatecells)'>Expand this characteristic (let it differentiate cells)</span>







  <span class='languageStringText' i18n='@@export' id='languageStringTextexport'>export</span>

  <span class='languageStringText' i18n='@@FACEBOOK' id='languageStringTextFACEBOOK'>FACEBOOK</span>


  <span class='languageStringText' i18n='@@facility' id='languageStringTextfacility'>facility</span>
  <span class='languageStringText' i18n='@@Facility' id='languageStringTextFacility'>Facility</span>






  <span class='languageStringText' i18n='@@facilityInventoryProduct' id='languageStringTextfacilityInventoryProduct'>facilityInventoryProduct</span>

  <span class='languageStringText' i18n='@@facilityInvoice' id='languageStringTextfacilityInvoice'>facilityInvoice</span>








  <span class='languageStringText' i18n='@@Failed to load exemption details.' id='languageStringTextFailedtoloadexemptiondetails.'>Failed to load exemption details.</span>
  <span class='languageStringText' i18n='@@Failed to load exemption review queue.' id='languageStringTextFailedtoloadexemptionreviewqueue.'>Failed to load exemption review queue.</span>
  <span class='languageStringText' i18n='@@Failed to load Sales Tax configuration.' id='languageStringTextFailedtoloadSalesTaxconfiguration.'>Failed to load Sales Tax configuration.</span>
  <span class='languageStringText' i18n='@@Failed to load Sales Tax Exemption.' id='languageStringTextFailedtoloadSalesTaxExemption.'>Failed to load Sales Tax Exemption.</span>

  <span class='languageStringText' i18n='@@Failed to obtain certificate download URL.' id='languageStringTextFailedtoobtaincertificatedownloadURL.'>Failed to obtain certificate download URL.</span>
  <span class='languageStringText' i18n='@@Failed to obtain upload URL from server.' id='languageStringTextFailedtoobtainuploadURLfromserver.'>Failed to obtain upload URL from server.</span>
  <span class='languageStringText' i18n='@@Failed to save Sales Tax configuration.' id='languageStringTextFailedtosaveSalesTaxconfiguration.'>Failed to save Sales Tax configuration.</span>
  <span class='languageStringText' i18n='@@Failed to save Sales Tax Exemption.' id='languageStringTextFailedtosaveSalesTaxExemption.'>Failed to save Sales Tax Exemption.</span>

  <span class='languageStringText' i18n='@@Failedtosavechapter' id='languageStringTextFailedtosavechapter'>Failedtosavechapter</span>





  <span class='languageStringText' i18n='@@File is too large. Maximum size is 10 MB.' id='languageStringTextFileistoolarge.Maximumsizeis10MB.'>File is too large. Maximum size is 10 MB.</span>

  <!--
    Resource PDF upload (presigned POST). Neither limit is baked into these
    strings: the size comes from `upload.maxBytes` and the rate limit from the
    429 body`s `limit`, both read from the response at runtime. The server
    raises both per environment, so a number here would go stale silently.
    See docs/contracts/shared/ResourceUploads.md.
  -->
  <span class='languageStringText' i18n='@@This file is too large to upload.' id='languageStringTextThisfileistoolargetoupload.'>This file is too large to upload.</span>
  <span class='languageStringText' i18n='@@The maximum size is' id='languageStringTextThemaximumsizeis'>The maximum size is</span>
  <span class='languageStringText' i18n='@@Upload limit reached for this organization.' id='languageStringTextUploadlimitreachedforthisorganization.'>Upload limit reached for this organization.</span>
  <span class='languageStringText' i18n='@@The limit is' id='languageStringTextThelimitis'>The limit is</span>
  <span class='languageStringText' i18n='@@uploads per hour.' id='languageStringTextuploadsperhour.'>uploads per hour.</span>
  <span class='languageStringText' i18n='@@Please try again in' id='languageStringTextPleasetryagainin'>Please try again in</span>
  <span class='languageStringText' i18n='@@minutes.' id='languageStringTextminutes.'>minutes.</span>
  <span class='languageStringText' i18n='@@The upload link expired. Please try again.' id='languageStringTextTheuploadlinkexpired.Pleasetryagain.'>The upload link expired. Please try again.</span>
  <span class='languageStringText' i18n='@@The server rejected the upload.' id='languageStringTextTheserverrejectedtheupload.'>The server rejected the upload.</span>
  <span class='languageStringText' i18n='@@Please try again shortly.' id='languageStringTextPleasetryagainshortly.'>Please try again shortly.</span>
  <span class='languageStringText' i18n='@@The upload could not be confirmed. It may have completed. Please reload before trying again.' id='languageStringTextTheuploadcouldnotbeconfirmed.Itmayhavecompleted.Pleasereloadbeforetryingagain.'>The upload could not be confirmed. It may have completed. Please reload before trying again.</span>
















  <span class='languageStringText' i18n='@@FIRSTCLASS' id='languageStringTextFIRSTCLASS'>First Class</span>



  <span class='languageStringText' i18n='@@Fold this value into the collapsed (—) row' id='languageStringTextFoldthisvalueintothecollapsed(—)row'>Fold this value into the collapsed (—) row</span>











  <span class='languageStringText' i18n='@@Font Weight (Bold)' id='languageStringTextFontWeight(Bold)'>Font Weight (Bold)</span>





  <span class='languageStringText' i18n='@@Fredericka the Great' id='languageStringTextFrederickatheGreat'>Fredericka the Great</span>




  <span class='languageStringText' i18n='@@Fresh' id='languageStringTextFresh'>Fresh</span>

  <span class='languageStringText' i18n='@@front' id='languageStringTextfront'>front</span>
  <span class='languageStringText' i18n='@@front-author-1' id='languageStringTextfront-author-1'>front-author-1</span>
  <span class='languageStringText' i18n='@@front-author-2' id='languageStringTextfront-author-2'>front-author-2</span>
  <span class='languageStringText' i18n='@@front-author-3' id='languageStringTextfront-author-3'>front-author-3</span>
  <span class='languageStringText' i18n='@@front-background' id='languageStringTextfront-background'>front-background</span>
  <span class='languageStringText' i18n='@@front-background-image' id='languageStringTextfront-background-image'>front-background-image</span>
  <span class='languageStringText' i18n='@@front-border-image' id='languageStringTextfront-border-image'>front-border-image</span>
  <span class='languageStringText' i18n='@@front-category' id='languageStringTextfront-category'>front-category</span>
  <span class='languageStringText' i18n='@@front-circle-1' id='languageStringTextfront-circle-1'>front-circle-1</span>
  <span class='languageStringText' i18n='@@front-circle-2' id='languageStringTextfront-circle-2'>front-circle-2</span>
  <span class='languageStringText' i18n='@@front-edition' id='languageStringTextfront-edition'>front-edition</span>
  <span class='languageStringText' i18n='@@front-forward-by' id='languageStringTextfront-forward-by'>front-forward-by</span>
  <span class='languageStringText' i18n='@@front-frame' id='languageStringTextfront-frame'>front-frame</span>
  <span class='languageStringText' i18n='@@front-image-1' id='languageStringTextfront-image-1'>front-image-1</span>
  <span class='languageStringText' i18n='@@front-image-2' id='languageStringTextfront-image-2'>front-image-2</span>
  <span class='languageStringText' i18n='@@front-introduction-by' id='languageStringTextfront-introduction-by'>front-introduction-by</span>
  <span class='languageStringText' i18n='@@front-line' id='languageStringTextfront-line'>front-line</span>
  <span class='languageStringText' i18n='@@front-line-behind-text' id='languageStringTextfront-line-behind-text'>front-line-behind-text</span>
  <span class='languageStringText' i18n='@@front-publisher-1' id='languageStringTextfront-publisher-1'>front-publisher-1</span>
  <span class='languageStringText' i18n='@@front-publisher-2' id='languageStringTextfront-publisher-2'>front-publisher-2</span>
  <span class='languageStringText' i18n='@@front-publisher-logo' id='languageStringTextfront-publisher-logo'>front-publisher-logo</span>
  <span class='languageStringText' i18n='@@front-rectangle-1' id='languageStringTextfront-rectangle-1'>front-rectangle-1</span>
  <span class='languageStringText' i18n='@@front-rectangle-2' id='languageStringTextfront-rectangle-2'>front-rectangle-2</span>
  <span class='languageStringText' i18n='@@front-rectangle-3' id='languageStringTextfront-rectangle-3'>front-rectangle-3</span>
  <span class='languageStringText' i18n='@@front-rectangle-4' id='languageStringTextfront-rectangle-4'>front-rectangle-4</span>
  <span class='languageStringText' i18n='@@front-series' id='languageStringTextfront-series'>front-series</span>
  <span class='languageStringText' i18n='@@front-series-1' id='languageStringTextfront-series-1'>front-series-1</span>
  <span class='languageStringText' i18n='@@front-series-2' id='languageStringTextfront-series-2'>front-series-2</span>
  <span class='languageStringText' i18n='@@front-series-3' id='languageStringTextfront-series-3'>front-series-3</span>
  <span class='languageStringText' i18n='@@front-tag-line-1' id='languageStringTextfront-tag-line-1'>front-tag-line-1</span>
  <span class='languageStringText' i18n='@@front-tag-line-2' id='languageStringTextfront-tag-line-2'>front-tag-line-2</span>
  <span class='languageStringText' i18n='@@front-tag-line-3' id='languageStringTextfront-tag-line-3'>front-tag-line-3</span>
  <span class='languageStringText' i18n='@@front-text-1' id='languageStringTextfront-text-1'>front-text-1</span>
  <span class='languageStringText' i18n='@@front-text-2' id='languageStringTextfront-text-2'>front-text-2</span>
  <span class='languageStringText' i18n='@@front-text-3' id='languageStringTextfront-text-3'>front-text-3</span>
  <span class='languageStringText' i18n='@@front-text-4' id='languageStringTextfront-text-4'>front-text-4</span>
  <span class='languageStringText' i18n='@@front-title-1' id='languageStringTextfront-title-1'>front-title-1</span>
  <span class='languageStringText' i18n='@@front-title-2' id='languageStringTextfront-title-2'>front-title-2</span>
  <span class='languageStringText' i18n='@@front-title-3' id='languageStringTextfront-title-3'>front-title-3</span>
  <span class='languageStringText' i18n='@@front-title-4' id='languageStringTextfront-title-4'>front-title-4</span>
  <span class='languageStringText' i18n='@@front-transparent-image' id='languageStringTextfront-transparent-image'>front-transparent-image</span>
  <span class='languageStringText' i18n='@@front-volume' id='languageStringTextfront-volume'>front-volume</span>
  <span class='languageStringText' i18n='@@frontBack' id='languageStringTextfrontBack'>frontBack</span>
  <span class='languageStringText' i18n='@@frontBack2' id='languageStringTextfrontBack2'>frontBack2</span>
  <span class='languageStringText' i18n='@@frontBack3' id='languageStringTextfrontBack3'>frontBack3</span>
  <span class='languageStringText' i18n='@@frontCircle' id='languageStringTextfrontCircle'>frontCircle</span>
  <span class='languageStringText' i18n='@@frontLine' id='languageStringTextfrontLine'>frontLine</span>
  <span class='languageStringText' i18n='@@frontText' id='languageStringTextfrontText'>frontText</span>
  <span class='languageStringText' i18n='@@frontText2' id='languageStringTextfrontText2'>frontText2</span>
  <span class='languageStringText' i18n='@@frontText3' id='languageStringTextfrontText3'>frontText3</span>





  <span class='languageStringText' i18n='@@Fun' id='languageStringTextFun'>Fun</span>
  <span class='languageStringText' i18n='@@FunctionalStatusPrefix' id='languageStringTextFunctionalStatusPrefix'>FunctionalStatusPrefix</span>
  <span class='languageStringText' i18n='@@FuntionalStatus' id='languageStringTextFuntionalStatus'>FuntionalStatus</span>












  <span class='languageStringText' i18n='@@GentiumBookBasic' id='languageStringTextGentiumBookBasic'>GentiumBookBasic</span>

  <span class='languageStringText' i18n='@@georgian' id='languageStringTextgeorgian'>georgian</span>









  <span class='languageStringText' i18n='@@GLOSS' id='languageStringTextGLOSS'>Gloss</span>








  <span class='languageStringText' i18n='@@GRAY' id='languageStringTextGRAY'>Gray</span>








  <span class='languageStringText' i18n='@@GROUND' id='languageStringTextGROUND'>Ground</span>










  <span class='languageStringText' i18n='@@H' id='languageStringTextH'>H</span>

  <span class='languageStringText' i18n='@@Happy' id='languageStringTextHappy'>Happy</span>
  <span class='languageStringText' i18n='@@HappyMonkey' id='languageStringTextHappyMonkey'>HappyMonkey</span>


  <span class='languageStringText' i18n='@@Heading1' id='languageStringTextHeading1'>Heading1</span>
  <span class='languageStringText' i18n='@@Heading2' id='languageStringTextHeading2'>Heading2</span>
  <span class='languageStringText' i18n='@@Heading3' id='languageStringTextHeading3'>Heading3</span>
  <span class='languageStringText' i18n='@@Heading4' id='languageStringTextHeading4'>Heading4</span>
  <span class='languageStringText' i18n='@@Heading5' id='languageStringTextHeading5'>Heading5</span>
  <span class='languageStringText' i18n='@@Heading6' id='languageStringTextHeading6'>Heading6</span>
  <span class='languageStringText' i18n='@@Heavy' id='languageStringTextHeavy'>Heavy</span>
  <span class='languageStringText' i18n='@@hebrew' id='languageStringTexthebrew'>hebrew</span>
  <span class='languageStringText' i18n='@@Height' id='languageStringTextHeight'>Height</span>













































  <span class='languageStringText' i18n='@@Hide the — slot on this characteristic' id='languageStringTextHidethe—slotonthischaracteristic'>Hide the — slot on this characteristic</span>






  <span class='languageStringText' i18n='@@hiragana' id='languageStringTexthiragana'>hiragana</span>
  <span class='languageStringText' i18n='@@hiragana-iroha' id='languageStringTexthiragana-iroha'>hiragana-iroha</span>







  <span class='languageStringText' i18n='@@hours' id='languageStringTexthours'>hours</span>





  <span class='languageStringText' i18n='@@Id' id='languageStringTextId'>Id</span>
  <span class='languageStringText' i18n='@@ID' id='languageStringTextID'>Id</span>










  <span class='languageStringText' i18n='@@image' id='languageStringTextimage'>image</span>










  <span class='languageStringText' i18n='@@IN_PROGRESS' id='languageStringTextIN_PROGRESS'>IN_PROGRESS</span>
  <span class='languageStringText' i18n='@@inactive' id='languageStringTextinactive'>inactive</span>
  <span class='languageStringText' i18n='@@Inactive' id='languageStringTextInactive'>Inactive</span>


  <span class='languageStringText' i18n='@@Incorrect username or password.' id='languageStringTextIncorrectusernameorpassword.'>Incorrect username or password.</span>





  <span class='languageStringText' i18n='@@Increased by' id='languageStringTextIncreasedby'>Increased by</span>





  <span class='languageStringText' i18n='@@Infeasible: factor' id='languageStringTextInfeasible:factor'>Infeasible: factor</span>

  <span class='languageStringText' i18n='@@INFO_REQUESTED' id='languageStringTextINFO_REQUESTED'>Information Requested</span>
  <span class='languageStringText' i18n='@@Inherit' id='languageStringTextInherit'>Inherit</span>



  <span class='languageStringText' i18n='@@INITIAL' id='languageStringTextINITIAL'>Initial</span>
  <span class='languageStringText' i18n='@@Initial' id='languageStringTextInitial'>Initial</span>
  <span class='languageStringText' i18n='@@Initial Quantity' id='languageStringTextInitialQuantity'>Initial Quantity</span>


  <span class='languageStringText' i18n='@@InitialStatus' id='languageStringTextInitialStatus'>InitialStatus</span>
  <span class='languageStringText' i18n='@@InProgress' id='languageStringTextInProgress'>InProgress</span>
  <span class='languageStringText' i18n='@@INSERT' id='languageStringTextINSERT'>Insert</span>

  <span class='languageStringText' i18n='@@Inside' id='languageStringTextInside'>Inside</span>
  <span class='languageStringText' i18n='@@Interior' id='languageStringTextInterior'>Interior</span>




  <span class='languageStringText' i18n='@@Interior Type' id='languageStringTextInteriorType'>Interior Type</span>

  <span class='languageStringText' i18n='@@Introduction' id='languageStringTextIntroduction'>Introduction</span>


  <span class='languageStringText' i18n='@@INVALID_ASSIGN_FACILITY' id='languageStringTextINVALID_ASSIGN_FACILITY'>INVALID_ASSIGN_FACILITY</span>
  <span class='languageStringText' i18n='@@INVALID_COMPUTE_PRODUCTION_COSTS' id='languageStringTextINVALID_COMPUTE_PRODUCTION_COSTS'>INVALID_COMPUTE_PRODUCTION_COSTS</span>
  <span class='languageStringText' i18n='@@INVALID_COMPUTE_TAX' id='languageStringTextINVALID_COMPUTE_TAX'>INVALID_COMPUTE_TAX</span>
  <span class='languageStringText' i18n='@@INVALID_CREATE_PACKAGES' id='languageStringTextINVALID_CREATE_PACKAGES'>INVALID_CREATE_PACKAGES</span>
  <span class='languageStringText' i18n='@@INVALID_FUNCTIONAL_INPUTS' id='languageStringTextINVALID_FUNCTIONAL_INPUTS'>INVALID_FUNCTIONAL_INPUTS</span>
  <span class='languageStringText' i18n='@@INVALID_RATE_SHIPPING' id='languageStringTextINVALID_RATE_SHIPPING'>INVALID_RATE_SHIPPING</span>
  <span class='languageStringText' i18n='@@INVALID_RAW_ORDER' id='languageStringTextINVALID_RAW_ORDER'>INVALID_RAW_ORDER</span>





  <span class='languageStringText' i18n='@@Inventory Management Type' id='languageStringTextInventoryManagementType'>Inventory Management Type</span>


  <span class='languageStringText' i18n='@@Inventory Type' id='languageStringTextInventoryType'>Inventory Type</span>
















  <span class='languageStringText' i18n='@@issue' id='languageStringTextissue'>issue</span>




  <span class='languageStringText' i18n='@@Issuing state of your certificate.' id='languageStringTextIssuingstateofyourcertificate.'>Issuing state of your certificate.</span>
  <span class='languageStringText' i18n='@@Italic' id='languageStringTextItalic'>Italic</span>



  <span class='languageStringText' i18n='@@Item already packed in a printed/shipped package' id='languageStringTextItemalreadypackedinaprinted/shippedpackage'>Item already packed in a printed/shipped package</span>


  <span class='languageStringText' i18n='@@Item is in a closed manufacturing set — quantity is locked and it cannot move to a different order.' id='languageStringTextItemisinaclosedmanufacturingset—quantityislockedanditcannotmovetoadifferentorder.'>Item is in a closed manufacturing set — quantity is locked and it cannot move to a different order.</span>










  <span class='languageStringText' i18n='@@Jazzy' id='languageStringTextJazzy'>Jazzy</span>




  <span class='languageStringText' i18n='@@justify' id='languageStringTextjustify'>justify</span>

  <span class='languageStringText' i18n='@@Karla' id='languageStringTextKarla'>Karla</span>
  <span class='languageStringText' i18n='@@katakana' id='languageStringTextkatakana'>katakana</span>
  <span class='languageStringText' i18n='@@katakana-iroha' id='languageStringTextkatakana-iroha'>katakana-iroha</span>








  <span class='languageStringText' i18n='@@L' id='languageStringTextL'>L</span>


  <span class='languageStringText' i18n='@@Laminate' id='languageStringTextLaminate'>Laminate</span>
  <span class='languageStringText' i18n='@@Laminate type' id='languageStringTextLaminatetype'>Laminate type</span>













  <span class='languageStringText' i18n='@@Lean' id='languageStringTextLean'>Lean</span>

  <span class='languageStringText' i18n='@@Left' id='languageStringTextLeft'>Left</span>


  <span class='languageStringText' i18n='@@Left Horizontal Shift' id='languageStringTextLeftHorizontalShift'>Left Horizontal Shift</span>


  <span class='languageStringText' i18n='@@Left Vertical Shift' id='languageStringTextLeftVerticalShift'>Left Vertical Shift</span>

  <span class='languageStringText' i18n='@@LEVEL' id='languageStringTextLEVEL'>Level</span>


  <span class='languageStringText' i18n='@@Library' id='languageStringTextLibrary'>Library</span>

  <span class='languageStringText' i18n='@@LibraryToolTip' id='languageStringTextLibraryToolTip'>Books and drafts</span>
  <span class='languageStringText' i18n='@@LibreBaskerville' id='languageStringTextLibreBaskerville'>LibreBaskerville</span>


  <span class='languageStringText' i18n='@@Light' id='languageStringTextLight'>Light</span>

  <span class='languageStringText' i18n='@@Lighter' id='languageStringTextLighter'>Lighter</span>



  <span class='languageStringText' i18n='@@line' id='languageStringTextline'>line</span>








  <span class='languageStringText' i18n='@@list' id='languageStringTextlist'>list</span>


  <span class='languageStringText' i18n='@@ListItem' id='languageStringTextListItem'>ListItem</span>
  <span class='languageStringText' i18n='@@ListItemInsideListItem' id='languageStringTextListItemInsideListItem'>ListItemInsideListItem</span>

  <span class='languageStringText' i18n='@@LOADED' id='languageStringTextLOADED'>LOADED</span>
  <span class='languageStringText' i18n='@@LOADING' id='languageStringTextLOADING'>LOADING</span>









  <span class='languageStringText' i18n='@@Location' id='languageStringTextLocation'>Location</span>






  <span class='languageStringText' i18n='@@lower-alpha' id='languageStringTextlower-alpha'>lower-alpha</span>
  <span class='languageStringText' i18n='@@lower-greek' id='languageStringTextlower-greek'>lower-greek</span>
  <span class='languageStringText' i18n='@@lower-latin' id='languageStringTextlower-latin'>lower-latin</span>
  <span class='languageStringText' i18n='@@lower-roman' id='languageStringTextlower-roman'>lower-roman</span>




  <span class='languageStringText' i18n='@@MAGENTO' id='languageStringTextMAGENTO'>MAGENTO</span>
  <span class='languageStringText' i18n='@@Main Organization Name' id='languageStringTextMainOrganizationName'>Main Organization Name</span>
  <span class='languageStringText' i18n='@@mainTitle' id='languageStringTextmainTitle'>mainTitle</span>
  <span class='languageStringText' i18n='@@mainTitle1' id='languageStringTextmainTitle1'>mainTitle1</span>
  <span class='languageStringText' i18n='@@mainTitle2' id='languageStringTextmainTitle2'>mainTitle2</span>
  <span class='languageStringText' i18n='@@mainTitleBackground' id='languageStringTextmainTitleBackground'>mainTitleBackground</span>































  <span class='languageStringText' i18n='@@manufacturingResource' id='languageStringTextmanufacturingResource'>Resource</span>
  <span class='languageStringText' i18n='@@MANUFACTURINGSET' id='languageStringTextMANUFACTURINGSET'>Manufacturing Set</span>
  <span class='languageStringText' i18n='@@manufacturingSet' id='languageStringTextmanufacturingSet'>Set</span>

  <span class='languageStringText' i18n='@@manufacturingTask' id='languageStringTextmanufacturingTask'>Task</span>
  <span class='languageStringText' i18n='@@manufacturingTaskBucket' id='languageStringTextmanufacturingTaskBucket'>Task Bucket</span>
  <span class='languageStringText' i18n='@@manufacturingTaskBucketPeriod' id='languageStringTextmanufacturingTaskBucketPeriod'>Task Bucket Period</span>


  <span class='languageStringText' i18n='@@Margin (break-even)' id='languageStringTextMargin(break-even)'>Margin (break-even)</span>

  <span class='languageStringText' i18n='@@Margin (loss)' id='languageStringTextMargin(loss)'>Margin (loss)</span>
  <span class='languageStringText' i18n='@@Margin (profit)' id='languageStringTextMargin(profit)'>Margin (profit)</span>

















  <span class='languageStringText' i18n='@@MATTE' id='languageStringTextMATTE'>Matte</span>






  <span class='languageStringText' i18n='@@MEDIA' id='languageStringTextMEDIA'>Media</span>

  <span class='languageStringText' i18n='@@Medium' id='languageStringTextMedium'>Medium</span>

  <span class='languageStringText' i18n='@@Message' id='languageStringTextMessage'>Message</span>


  <span class='languageStringText' i18n='@@Michroma' id='languageStringTextMichroma'>Michroma</span>







  <span class='languageStringText' i18n='@@minute ago' id='languageStringTextminuteago'>minute ago</span>

  <span class='languageStringText' i18n='@@minutes ago' id='languageStringTextminutesago'>minutes ago</span>








  <span class='languageStringText' i18n='@@MontserratAlternates' id='languageStringTextMontserratAlternates'>MontserratAlternates</span>





  <span class='languageStringText' i18n='@@moreActions' id='languageStringTextmoreActions'>moreActions</span>

































  <span class='languageStringText' i18n='@@mutableBook' id='languageStringTextmutableBook'>Draft</span>







  <span class='languageStringText' i18n='@@Name' id='languageStringTextName'>Name</span>










  <span class='languageStringText' i18n='@@NeedExpirationMonthAndYear' id='languageStringTextNeedExpirationMonthAndYear'>Enter both an expiration month and year</span>


  <span class='languageStringText' i18n='@@NestedBullets' id='languageStringTextNestedBullets'>NestedBullets</span>
  <span class='languageStringText' i18n='@@Net' id='languageStringTextNet'>Net</span>





  <span class='languageStringText' i18n='@@Network' id='languageStringTextNetwork'>Network</span>
  <span class='languageStringText' i18n='@@network cost' id='languageStringTextnetworkcost'>network cost</span>
  <span class='languageStringText' i18n='@@Network does not quote a cost for this combo.' id='languageStringTextNetworkdoesnotquoteacostforthiscombo.'>Network does not quote a cost for this combo.</span>
  <span class='languageStringText' i18n='@@network packing cost' id='languageStringTextnetworkpackingcost'>network packing cost</span>









  <span class='languageStringText' i18n='@@Newly infeasible (was priced)' id='languageStringTextNewlyinfeasible(waspriced)'>Newly infeasible (was priced)</span>
  <span class='languageStringText' i18n='@@Newly priced (was infeasible)' id='languageStringTextNewlypriced(wasinfeasible)'>Newly priced (was infeasible)</span>
  <span class='languageStringText' i18n='@@NewsCycle' id='languageStringTextNewsCycle'>NewsCycle</span>



  <span class='languageStringText' i18n='@@Next Tasks' id='languageStringTextNextTasks'>Next Tasks</span>










  <span class='languageStringText' i18n='@@no cost quoted' id='languageStringTextnocostquoted'>no cost quoted</span>




  <span class='languageStringText' i18n='@@No exemption on file' id='languageStringTextNoexemptiononfile'>No exemption on file</span>

  <span class='languageStringText' i18n='@@No factors yet -- add a factor to populate the demonstration.' id='languageStringTextNofactorsyet--addafactortopopulatethedemonstration.'>No factors yet -- add a factor to populate the demonstration.</span>

  <span class='languageStringText' i18n='@@No facility can fulfill this order' id='languageStringTextNofacilitycanfulfillthisorder'>No facility can fulfill this order</span>













  <span class='languageStringText' i18n='@@No Title Set' id='languageStringTextNoTitleSet'>No Title Set</span>






  <span class='languageStringText' i18n='@@non-exempt' id='languageStringTextnon-exempt'>non-exempt</span>

  <span class='languageStringText' i18n='@@none' id='languageStringTextnone'>none</span>


  <span class='languageStringText' i18n='@@NoProjectsWelcome' id='languageStringTextNoProjectsWelcome'>NoProjectsWelcome</span>

  <span class='languageStringText' i18n='@@Normal' id='languageStringTextNormal'>Normal</span>

  <span class='languageStringText' i18n='@@Not Found' id='languageStringTextNotFound'>Not Found</span>

  <span class='languageStringText' i18n='@@Not Ready To Release To Production' id='languageStringTextNotReadyToReleaseToProduction'>Not Ready To Release To Production</span>
  <span class='languageStringText' i18n='@@Not Set' id='languageStringTextNotSet'>Not Set</span>
  <span class='languageStringText' i18n='@@Not Started' id='languageStringTextNotStarted'>Not Started</span>
  <span class='languageStringText' i18n='@@PreliminaryPreviewLabel' id='languageStringTextPreliminaryPreviewLabel'>Preliminary preview</span>
  <span class='languageStringText' i18n='@@PreliminaryPreviewPreparingHint' id='languageStringTextPreliminaryPreviewPreparingHint'>This image is from the uploaded PDF. It will be replaced when preparation is complete.</span>
  <span class='languageStringText' i18n='@@PreliminaryPreviewStandardizingHint' id='languageStringTextPreliminaryPreviewStandardizingHint'>This image is from the prepared PDF. It will be replaced when standardization is complete.</span>
  <span class='languageStringText' i18n='@@PreviewProcessingErrorHint' id='languageStringTextPreviewProcessingErrorHint'>This PDF could not be processed. The image shown may not match what is printed.</span>




  <span class='languageStringText' i18n='@@NotAllProductsAreMapped' id='languageStringTextNotAllProductsAreMapped'>NotAllProductsAreMapped</span>







  <span class='languageStringText' i18n='@@NotoSans' id='languageStringTextNotoSans'>NotoSans</span>
  <span class='languageStringText' i18n='@@NotoSerif' id='languageStringTextNotoSerif'>NotoSerif</span>


  <span class='languageStringText' i18n='@@now 8' id='languageStringTextnow8'>now 8</span>






  <span class='languageStringText' i18n='@@Oblique' id='languageStringTextOblique'>Oblique</span>






  <span class='languageStringText' i18n='@@On Hold' id='languageStringTextOnHold'>On Hold</span>



  <span class='languageStringText' i18n='@@OPEN' id='languageStringTextOPEN'>Open</span>





  <span class='languageStringText' i18n='@@Order' id='languageStringTextOrder'>Order</span>





  <span class='languageStringText' i18n='@@Order Id' id='languageStringTextOrderId'>Order Id</span>



  <span class='languageStringText' i18n='@@Order Is Being Ignored' id='languageStringTextOrderIsBeingIgnored'>Order Is Being Ignored</span>

  <span class='languageStringText' i18n='@@Order On User Hold' id='languageStringTextOrderOnUserHold'>Order On User Hold</span>













  <span class='languageStringText' i18n='@@OrderedListItem' id='languageStringTextOrderedListItem'>OrderedListItem</span>
  <span class='languageStringText' i18n='@@orderItem' id='languageStringTextorderItem'>orderItem</span>

  <span class='languageStringText' i18n='@@orderItemToPackage' id='languageStringTextorderItemToPackage'>orderItemToPackage</span>












  <span class='languageStringText' i18n='@@Org' id='languageStringTextOrg'>Org</span>
  <span class='languageStringText' i18n='@@Org Id' id='languageStringTextOrgId'>Org Id</span>
  <span class='languageStringText' i18n='@@Organization' id='languageStringTextOrganization'>Organization</span>
  <span class='languageStringText' i18n='@@organization' id='languageStringTextorganization'>organization</span>
  <span class='languageStringText' i18n='@@Organization Name' id='languageStringTextOrganizationName'>Organization Name</span>
  <span class='languageStringText' i18n='@@organizationInvoice' id='languageStringTextorganizationInvoice'>Organization Invoice</span>



  <span class='languageStringText' i18n='@@OrgId' id='languageStringTextOrgId'>Organization Id</span>



  <span class='languageStringText' i18n='@@other' id='languageStringTextother'>other</span>
  <span class='languageStringText' i18n='@@Other' id='languageStringTextOther'>Other</span>

  <span class='languageStringText' i18n='@@Outside' id='languageStringTextOutside'>Outside</span>


  <span class='languageStringText' i18n='@@Pacifico' id='languageStringTextPacifico'>Pacifico</span>
  <span class='languageStringText' i18n='@@Pack' id='languageStringTextPack'>Pack</span>
  <span class='languageStringText' i18n='@@Package' id='languageStringTextPackage'>Package</span>
  <span class='languageStringText' i18n='@@package' id='languageStringTextpackage'>package</span>

  <span class='languageStringText' i18n='@@Package changes saved.' id='languageStringTextPackagechangessaved.'>Package changes saved.</span>
  <span class='languageStringText' i18n='@@Package Creation' id='languageStringTextPackageCreation'>Package Creation</span>
  <span class='languageStringText' i18n='@@Package type' id='languageStringTextPackagetype'>Package type</span>



  <span class='languageStringText' i18n='@@packageType' id='languageStringTextpackageType'>packageType</span>













  <span class='languageStringText' i18n='@@pages' id='languageStringTextpages'>pages</span>
  <span class='languageStringText' i18n='printed pages|Count of pages in the book. One physical sheet carries several pages, so this must not share a word with Sheets.@@Pages' id='languageStringTextPages'>Pages</span>






  <span class='languageStringText' i18n='@@Paper' id='languageStringTextPaper'>Paper</span>

  <span class='languageStringText' i18n='@@paperType' id='languageStringTextpaperType'>Paper Type</span>

  <span class='languageStringText' i18n='@@Paragraph' id='languageStringTextParagraph'>Paragraph</span>
  <span class='languageStringText' i18n='@@paragraphs' id='languageStringTextparagraphs'>paragraphs</span>













  <span class='languageStringText' i18n='@@PAYPAL' id='languageStringTextPAYPAL'>PAYPAL</span>

  <span class='languageStringText' i18n='@@peer ∞' id='languageStringTextpeer∞'>peer ∞</span>
  <span class='languageStringText' i18n='@@Pending' id='languageStringTextPending'>Pending</span>

  <span class='languageStringText' i18n='@@PENDING_REVIEW' id='languageStringTextPENDING_REVIEW'>Pending Review</span>




  <span class='languageStringText' i18n='@@Per package' id='languageStringTextPerpackage'>Per package</span>





  <span class='languageStringText' i18n='@@Percent' id='languageStringTextPercent'>Percent</span>

  <span class='languageStringText' i18n='@@PERFECT' id='languageStringTextPERFECT'>Perfect</span>


  <span class='languageStringText' i18n='@@Period' id='languageStringTextPeriod'>Period</span>










  <span class='languageStringText' i18n='@@PICKUP' id='languageStringTextPICKUP'>Pickup</span>








  <span class='languageStringText' i18n='@@Plaster' id='languageStringTextPlaster'>Plaster</span>







































  <span class='languageStringText' i18n='@@PortLligatSans' id='languageStringTextPortLligatSans'>PortLligatSans</span>





  <span class='languageStringText' i18n='@@Power' id='languageStringTextPower'>Power</span>
  <span class='languageStringText' i18n='@@PragatiNarrow' id='languageStringTextPragatiNarrow'>PragatiNarrow</span>


  <span class='languageStringText' i18n='@@Present' id='languageStringTextPresent'>Present</span>















  <span class='languageStringText' i18n='what the customer pays|Customer-facing selling price. Not the internal Cost.@@Price' id='languageStringTextPrice'>Price</span>









  <span class='languageStringText' i18n='@@PrimaryDark' id='languageStringTextPrimaryDark'>PrimaryDark</span>
  <span class='languageStringText' i18n='@@PrimaryLight' id='languageStringTextPrimaryLight'>PrimaryLight</span>
  <span class='languageStringText' i18n='@@PrimaryNormal' id='languageStringTextPrimaryNormal'>PrimaryNormal</span>
  <span class='languageStringText' i18n='@@PrimaryText' id='languageStringTextPrimaryText'>PrimaryText</span>























  <span class='languageStringText' i18n='@@printNodeOrder' id='languageStringTextprintNodeOrder'>printNodeOrder</span>
  <span class='languageStringText' i18n='@@printNodeOrderItem' id='languageStringTextprintNodeOrderItem'>printNodeOrderItem</span>
  <span class='languageStringText' i18n='@@PRIORITY' id='languageStringTextPRIORITY'>Priority</span>

  <span class='languageStringText' i18n='@@PRIORITY_FLAT' id='languageStringTextPRIORITY_FLAT'>PRIORITY_FLAT</span>


  <span class='languageStringText' i18n='@@Problem Getting Revenue From The In Coming Order' id='languageStringTextProblemGettingRevenueFromTheInComingOrder'>Problem Getting Revenue From The In Coming Order</span>
  <span class='languageStringText' i18n='@@Problem Matching Products' id='languageStringTextProblemMatchingProducts'>Problem Matching Products</span>











  <span class='languageStringText' i18n='@@product' id='languageStringTextproduct'>product</span>

  <span class='languageStringText' i18n='@@Product Id' id='languageStringTextProductId'>Product Id</span>




  <span class='languageStringText' i18n='@@Product Status' id='languageStringTextProductStatus'>Product Status</span>



  <span class='languageStringText' i18n='@@ProductAndShippingRevenueStatusPrefix' id='languageStringTextProductAndShippingRevenueStatusPrefix'>ProductAndShippingRevenueStatusPrefix</span>




  <span class='languageStringText' i18n='@@Production locations' id='languageStringTextProductionlocations'>Production locations</span>





  <span class='languageStringText' i18n='@@ProductStatusPrefix' id='languageStringTextProductStatusPrefix'>ProductStatusPrefix</span>

  <span class='languageStringText' i18n='@@project' id='languageStringTextproject'>project</span>






  <span class='languageStringText' i18n='@@ProstoOne' id='languageStringTextProstoOne'>ProstoOne</span>



  <span class='languageStringText' i18n='@@publisher' id='languageStringTextpublisher'>publisher</span>
  <span class='languageStringText' i18n='@@publisher2' id='languageStringTextpublisher2'>publisher2</span>






  <span class='languageStringText' i18n='@@Qty' id='languageStringTextQty'>Qty</span>
  <span class='languageStringText' i18n='@@Quantity' id='languageStringTextQuantity'>Quantity</span>



  <span class='languageStringText' i18n='@@Quantity Commited' id='languageStringTextQuantityCommited'>Quantity Commited</span>



  <span class='languageStringText' i18n='@@Quantity Not Shipped' id='languageStringTextQuantityNotShipped'>Quantity Not Shipped</span>
  <span class='languageStringText' i18n='@@Quantity On Hand' id='languageStringTextQuantityOnHand'>Quantity On Hand</span>
  <span class='languageStringText' i18n='@@Quantity On Order' id='languageStringTextQuantityOnOrder'>Quantity On Order</span>

  <span class='languageStringText' i18n='@@Quarantine' id='languageStringTextQuarantine'>Quarantine</span>



  <span class='languageStringText' i18n='@@Question' id='languageStringTextQuestion'>Question</span>


  <span class='languageStringText' i18n='@@R' id='languageStringTextR'>R</span>







  <span class='languageStringText' i18n='@@Ready To Release To Production' id='languageStringTextReadyToReleaseToProduction'>Ready To Release To Production</span>
  <span class='languageStringText' i18n='@@ReadyForRelease' id='languageStringTextReadyForRelease'>ReadyForRelease</span>







  <span class='languageStringText' i18n='@@RECEIVED' id='languageStringTextRECEIVED'>Received</span>







  <span class='languageStringText' i18n='@@rectangle' id='languageStringTextrectangle'>rectangle</span>






  <span class='languageStringText' i18n='@@Regal' id='languageStringTextRegal'>Regal</span>


  <span class='languageStringText' i18n='@@REJECTED' id='languageStringTextREJECTED'>Rejected</span>


  <span class='languageStringText' i18n='@@Released To Production' id='languageStringTextReleasedToProduction'>Released To Production</span>
  <span class='languageStringText' i18n='@@ReleasePendingBalance' id='languageStringTextReleasePendingBalance'>ReleasePendingBalance</span>

  <span class='languageStringText' i18n='@@Releasing To Production' id='languageStringTextReleasingToProduction'>Releasing To Production</span>




  <span class='languageStringText' i18n='@@Remote Order Status' id='languageStringTextRemoteOrderStatus'>Remote Order Status</span>

  <span class='languageStringText' i18n='@@Remote Store Order Id Has Already Been Created' id='languageStringTextRemoteStoreOrderIdHasAlreadyBeenCreated'>Remote Store Order Id Has Already Been Created</span>
  <span class='languageStringText' i18n='@@Remote Store Order Needs Review' id='languageStringTextRemoteStoreOrderNeedsReview'>Remote Store Order Needs Review</span>
  <span class='languageStringText' i18n='@@Remote Store Order Overridden' id='languageStringTextRemoteStoreOrderOverridden'>Remote Store Order Overridden</span>


  <span class='languageStringText' i18n='@@RemoteOrderStatusPrefix' id='languageStringTextRemoteOrderStatusPrefix'>RemoteOrderStatusPrefix</span>
























  <span class='languageStringText' i18n='@@Reorder Quantity' id='languageStringTextReorderQuantity'>Reorder Quantity</span>























  <span class='languageStringText' i18n='@@Requested' id='languageStringTextRequested'>Requested</span>













  <span class='languageStringText' i18n='@@resource' id='languageStringTextresource'>resource</span>





















  <span class='languageStringText' i18n='@@Revenue Status' id='languageStringTextRevenueStatus'>Revenue Status</span>




  <span class='languageStringText' i18n='@@Review action failed.' id='languageStringTextReviewactionfailed.'>Review action failed.</span>



  <span class='languageStringText' i18n='@@ReviewSource' id='languageStringTextReviewSource'>ReviewSource</span>
  <span class='languageStringText' i18n='@@ReviewStatus' id='languageStringTextReviewStatus'>ReviewStatus</span>




  <span class='languageStringText' i18n='@@REVOKED' id='languageStringTextREVOKED'>Revoked</span>
  <span class='languageStringText' i18n='@@Right' id='languageStringTextRight'>Right</span>


  <span class='languageStringText' i18n='@@Right Horizontal Shift' id='languageStringTextRightHorizontalShift'>Right Horizontal Shift</span>



  <span class='languageStringText' i18n='@@Right Vertical Shift' id='languageStringTextRightVerticalShift'>Right Vertical Shift</span>




  <span class='languageStringText' i18n='@@Rounded' id='languageStringTextRounded'>Rounded</span>





  <span class='languageStringText' i18n='@@SADDLE_STITCH' id='languageStringTextSADDLE_STITCH'>Saddle Stitch</span>





  <span class='languageStringText' i18n='@@Sales Tax Exemption submitted for review.' id='languageStringTextSalesTaxExemptionsubmittedforreview.'>Sales Tax Exemption submitted for review.</span>
  <span class='languageStringText' i18n='@@Sales Tax Exemption updated.' id='languageStringTextSalesTaxExemptionupdated.'>Sales Tax Exemption updated.</span>




































  <span class='languageStringText' i18n='image fit mode: shrink only|Image sizing mode. Only ever reduces the image; an image already smaller than the frame is left alone. Must be distinguishable from scale-up-to-fit (the opposite) and scale-to-fit (either direction).@@scale-down-to-fit' id='languageStringTextscale-down-to-fit'>scale-down-to-fit</span>
  <span class='languageStringText' i18n='image fit mode: either direction|Image sizing mode. Resizes the image in whichever direction is needed so it fits the frame - it may enlarge or reduce. Must be distinguishable from scale-down-to-fit and scale-up-to-fit, which are the one-directional variants; all three appear together in the same picker.@@scale-to-fit' id='languageStringTextscale-to-fit'>scale-to-fit</span>
  <span class='languageStringText' i18n='image fit mode: enlarge only|Image sizing mode. Only ever enlarges the image; an image already larger than the frame is left alone. Must be distinguishable from scale-down-to-fit (the opposite) and scale-to-fit (either direction).@@scale-up-to-fit' id='languageStringTextscale-up-to-fit'>scale-up-to-fit</span>







  <span class='languageStringText' i18n='@@Scripture' id='languageStringTextScripture'>Scripture</span>










  <span class='languageStringText' i18n='@@SecondaryDark' id='languageStringTextSecondaryDark'>SecondaryDark</span>
  <span class='languageStringText' i18n='@@SecondaryLight' id='languageStringTextSecondaryLight'>SecondaryLight</span>
  <span class='languageStringText' i18n='@@SecondaryNormal' id='languageStringTextSecondaryNormal'>SecondaryNormal</span>
  <span class='languageStringText' i18n='@@SecondaryText' id='languageStringTextSecondaryText'>SecondaryText</span>
  <span class='languageStringText' i18n='@@Section' id='languageStringTextSection'>Section</span>
  <span class='languageStringText' i18n='@@sections' id='languageStringTextsections'>sections</span>



  <span class='languageStringText' i18n='@@Select a payment method' id='languageStringTextSelectapaymentmethod'>Select a payment method</span>

  <span class='languageStringText' i18n='@@Select a shipping option' id='languageStringTextSelectashippingoption'>Select a shipping option</span>



  <span class='languageStringText' i18n='@@Select or enter an address' id='languageStringTextSelectorenteranaddress'>Select or enter an address</span>

















  <span class='languageStringText' i18n='@@SENT' id='languageStringTextSENT'>Sent</span>


  <span class='languageStringText' i18n='@@seriesTitle' id='languageStringTextseriesTitle'>seriesTitle</span>
  <span class='languageStringText' i18n='@@seriesTitle2' id='languageStringTextseriesTitle2'>seriesTitle2</span>
  <span class='languageStringText' i18n='@@seriesTitle3' id='languageStringTextseriesTitle3'>seriesTitle3</span>
  <span class='languageStringText' i18n='@@Service Level' id='languageStringTextServiceLevel'>Service Level</span>
  <span class='languageStringText' i18n='@@Service Provider' id='languageStringTextServiceProvider'>Service Provider</span>

  <span class='languageStringText' i18n='@@Service Provider does not accept your certificate as reciprocal evidence here.' id='languageStringTextServiceProviderdoesnotacceptyourcertificateasreciprocalevidencehere.'>Service Provider does not accept your certificate as reciprocal evidence here.</span>
  <span class='languageStringText' i18n='@@Service Provider does not collect tax in this state.' id='languageStringTextServiceProviderdoesnotcollecttaxinthisstate.'>Service Provider does not collect tax in this state.</span>









  <span class='languageStringText' i18n='@@Set' id='languageStringTextSet'>Set</span>
  <span class='languageStringText' i18n='@@Set item quantities to enable checkout' id='languageStringTextSetitemquantitiestoenablecheckout'>Set item quantities to enable checkout</span>














  <span class='languageStringText' i18n='physical sheets of paper|Count of physical sheets of paper fed through the press. Several pages are imposed on one sheet, so this must not share a word with Pages.@@Sheets' id='languageStringTextSheets'>Sheets</span>




  <span class='languageStringText' i18n='@@Shelf' id='languageStringTextShelf'>Shelf</span>





















  <span class='languageStringText' i18n='@@Ship' id='languageStringTextShip'>Ship</span>

























  <span class='languageStringText' i18n='@@Shipping Status' id='languageStringTextShippingStatus'>Shipping Status</span>



  <span class='languageStringText' i18n='@@SHOPIFY' id='languageStringTextSHOPIFY'>SHOPIFY</span>












  <span class='languageStringText' i18n='@@Show a — slot on this characteristic so cells can opt out of differentiating by it' id='languageStringTextShowa—slotonthischaracteristicsocellscanoptoutofdifferentiatingbyit'>Show a — slot on this characteristic so cells can opt out of differentiating by it</span>















































  <span class='languageStringText' i18n='@@Show Printed and Not Printed Picksheets' id='languageStringTextShowPrintedandNotPrintedPicksheets'>Show Printed and Not Printed Pick Sheets</span>







































































  <span class='languageStringText' i18n='@@Simon' id='languageStringTextSimon'>Simon</span>
  <span class='languageStringText' i18n='@@Simon Inventory' id='languageStringTextSimonInventory'>Simon Inventory</span>
  <span class='languageStringText' i18n='@@Simon Singles' id='languageStringTextSimonSingles'>Simon Singles</span>
  <span class='languageStringText' i18n='@@Simon Weekly' id='languageStringTextSimonWeekly'>Simon Weekly</span>
  <span class='languageStringText' i18n='@@Simple' id='languageStringTextSimple'>Simple</span>






  <span class='languageStringText' i18n='@@Smooth' id='languageStringTextSmooth'>Smooth</span>
  <span class='languageStringText' i18n='@@Sofia' id='languageStringTextSofia'>Sofia</span>

  <span class='languageStringText' i18n='@@Some items may need special handling to manufacture' id='languageStringTextSomeitemsmayneedspecialhandlingtomanufacture'>Some items may need special handling to manufacture</span>

















  <span class='languageStringText' i18n='@@spine' id='languageStringTextspine'>spine</span>
  <span class='languageStringText' i18n='@@spine-author-1' id='languageStringTextspine-author-1'>spine-author-1</span>
  <span class='languageStringText' i18n='@@spine-author-2' id='languageStringTextspine-author-2'>spine-author-2</span>
  <span class='languageStringText' i18n='@@spine-background' id='languageStringTextspine-background'>spine-background</span>
  <span class='languageStringText' i18n='@@spine-background-image' id='languageStringTextspine-background-image'>spine-background-image</span>
  <span class='languageStringText' i18n='@@spine-image-1' id='languageStringTextspine-image-1'>spine-image-1</span>
  <span class='languageStringText' i18n='@@spine-image-2' id='languageStringTextspine-image-2'>spine-image-2</span>
  <span class='languageStringText' i18n='@@spine-line-behind-text' id='languageStringTextspine-line-behind-text'>spine-line-behind-text</span>
  <span class='languageStringText' i18n='@@spine-publisher-logo' id='languageStringTextspine-publisher-logo'>spine-publisher-logo</span>
  <span class='languageStringText' i18n='@@spine-rectangle-1' id='languageStringTextspine-rectangle-1'>spine-rectangle-1</span>
  <span class='languageStringText' i18n='@@spine-rectangle-2' id='languageStringTextspine-rectangle-2'>spine-rectangle-2</span>
  <span class='languageStringText' i18n='@@spine-series' id='languageStringTextspine-series'>spine-series</span>
  <span class='languageStringText' i18n='@@spine-title-1' id='languageStringTextspine-title-1'>spine-title-1</span>
  <span class='languageStringText' i18n='@@spine-title-2' id='languageStringTextspine-title-2'>spine-title-2</span>
  <span class='languageStringText' i18n='@@spine-title-3' id='languageStringTextspine-title-3'>spine-title-3</span>
  <span class='languageStringText' i18n='@@spine-title-4' id='languageStringTextspine-title-4'>spine-title-4</span>
  <span class='languageStringText' i18n='@@spine-volume' id='languageStringTextspine-volume'>spine-volume</span>
  <span class='languageStringText' i18n='@@spineAuthor' id='languageStringTextspineAuthor'>spineAuthor</span>
  <span class='languageStringText' i18n='@@spineAuthor2' id='languageStringTextspineAuthor2'>spineAuthor2</span>
  <span class='languageStringText' i18n='@@spineBack' id='languageStringTextspineBack'>spineBack</span>
  <span class='languageStringText' i18n='@@spineBack2' id='languageStringTextspineBack2'>spineBack2</span>
  <span class='languageStringText' i18n='@@spineBack3' id='languageStringTextspineBack3'>spineBack3</span>
  <span class='languageStringText' i18n='@@spineLine' id='languageStringTextspineLine'>spineLine</span>
  <span class='languageStringText' i18n='@@spineMainTitle' id='languageStringTextspineMainTitle'>spineMainTitle</span>
  <span class='languageStringText' i18n='@@spineMainTitle2' id='languageStringTextspineMainTitle2'>spineMainTitle2</span>

  <span class='languageStringText' i18n='@@Split saved.' id='languageStringTextSplitsaved.'>Split saved.</span>
  <span class='languageStringText' i18n='@@square' id='languageStringTextsquare'>square</span>















  <span class='languageStringText' i18n='@@StandardBullets' id='languageStringTextStandardBullets'>StandardBullets</span>
  <span class='languageStringText' i18n='@@Standardized' id='languageStringTextStandardized'>Standardized</span>













  <span class='languageStringText' i18n='@@State' id='languageStringTextState'>State</span>


  <span class='languageStringText' i18n='@@Status' id='languageStringTextStatus'>Status</span>











  <span class='languageStringText' i18n='@@Strong' id='languageStringTextStrong'>Strong</span>





  <span class='languageStringText' i18n='@@Submitted' id='languageStringTextSubmitted'>Submitted</span>



  <span class='languageStringText' i18n='@@subTitle' id='languageStringTextsubTitle'>subTitle</span>


  <span class='languageStringText' i18n='@@SUCCESS' id='languageStringTextSUCCESS'>SUCCESS</span>
  <span class='languageStringText' i18n='@@SuccessfullyReleased' id='languageStringTextSuccessfullyReleased'>SuccessfullyReleased</span>





  <span class='languageStringText' i18n='@@SUPPORT' id='languageStringTextSUPPORT'>Support</span>


  <span class='languageStringText' i18n='@@Support Note' id='languageStringTextSupportNote'>Support Note</span>
  <span class='languageStringText' i18n='@@Support Person' id='languageStringTextSupportPerson'>Support Person</span>
  <span class='languageStringText' i18n='@@Support Status' id='languageStringTextSupportStatus'>Support Status</span>












  <span class='languageStringText' i18n='@@T' id='languageStringTextT'>T</span>


  <span class='languageStringText' i18n='@@TableofContents' id='languageStringTextTableofContents'>TableofContents</span>

  <span class='languageStringText' i18n='@@tagLine' id='languageStringTexttagLine'>tagLine</span>
  <span class='languageStringText' i18n='@@tagLine2' id='languageStringTexttagLine2'>tagLine2</span>
  <span class='languageStringText' i18n='@@tagLine3' id='languageStringTexttagLine3'>tagLine3</span>


  <span class='languageStringText' i18n='@@Tangerine' id='languageStringTextTangerine'>Tangerine</span>



  <span class='languageStringText' i18n='@@Tax' id='languageStringTextTax'>Tax</span>



















  <span class='languageStringText' i18n='@@textbox' id='languageStringTexttextbox'>textbox</span>
  <span class='languageStringText' i18n='@@Textdidnotloadforchapterid' id='languageStringTextTextdidnotloadforchapterid'>Textdidnotloadforchapterid</span>





  <span class='languageStringText' i18n='@@The change was rejected because of a conflict, but the server did not include details.' id='languageStringTextThechangewasrejectedbecauseofaconflict,buttheserverdidnotincludedetails.'>The change was rejected because of a conflict, but the server did not include details.</span>
  <span class='languageStringText' i18n='@@The change was rejected because one or more packages are protected. Approve the override(s) and try again.' id='languageStringTextThechangewasrejectedbecauseoneormorepackagesareprotected.Approvetheoverride(s)andtryagain.'>The change was rejected because one or more packages are protected. Approve the override(s) and try again.</span>
  <span class='languageStringText' i18n='@@The split was rejected because of a conflict, but the server did not include details.' id='languageStringTextThesplitwasrejectedbecauseofaconflict,buttheserverdidnotincludedetails.'>The split was rejected because of a conflict, but the server did not include details.</span>
  <span class='languageStringText' i18n='@@The split was rejected because one or more items or packages are protected.' id='languageStringTextThesplitwasrejectedbecauseoneormoreitemsorpackagesareprotected.'>The split was rejected because one or more items or packages are protected.</span>

  <span class='languageStringText' i18n='@@These items are no longer produced' id='languageStringTextTheseitemsarenolongerproduced'>These items are no longer produced</span>













  <span class='languageStringText' i18n='@@This rate refuses the combo but the cost is finite.' id='languageStringTextThisraterefusesthecombobutthecostisfinite.'>This rate refuses the combo but the cost is finite.</span>
  <span class='languageStringText' i18n='@@Tight' id='languageStringTextTight'>Tight</span>
  <span class='languageStringText' i18n='@@TimesNewRoman' id='languageStringTextTimesNewRoman'>TimesNewRoman</span>
  <span class='languageStringText' i18n='@@Title' id='languageStringTextTitle'>Title</span>
  <span class='languageStringText' i18n='@@TitleEmphasis' id='languageStringTextTitleEmphasis'>TitleEmphasis</span>
  <span class='languageStringText' i18n='@@TitleH1' id='languageStringTextTitleH1'>Title Heading 1</span>
  <span class='languageStringText' i18n='@@TitleH2' id='languageStringTextTitleH2'>Title Heading 2</span>
  <span class='languageStringText' i18n='@@TitleH3' id='languageStringTextTitleH3'>Title Heading 3</span>

  <span class='languageStringText' i18n='@@titlePage' id='languageStringTexttitlePage'>titlePage</span>

  <span class='languageStringText' i18n='@@TitleStrong' id='languageStringTextTitleStrong'>TitleStrong</span>

  <span class='languageStringText' i18n='@@TOCEmphasis' id='languageStringTextTOCEmphasis'>TOCEmphasis</span>
  <span class='languageStringText' i18n='@@TOCH1' id='languageStringTextTOCH1'>Table of Contents Heading 1</span>
  <span class='languageStringText' i18n='@@TOCHeader' id='languageStringTextTOCHeader'>TOCHeader</span>
  <span class='languageStringText' i18n='@@TOCHeaderChapterTitle' id='languageStringTextTOCHeaderChapterTitle'>TOCHeaderChapterTitle</span>
  <span class='languageStringText' i18n='@@TOCHeaderPageNumber' id='languageStringTextTOCHeaderPageNumber'>TOCHeaderPageNumber</span>
  <span class='languageStringText' i18n='@@TOCLine' id='languageStringTextTOCLine'>TOCLine</span>
  <span class='languageStringText' i18n='@@TOCLineChapterTitle' id='languageStringTextTOCLineChapterTitle'>TOCLineChapterTitle</span>
  <span class='languageStringText' i18n='@@TOCLinePageNumber' id='languageStringTextTOCLinePageNumber'>TOCLinePageNumber</span>
  <span class='languageStringText' i18n='@@TOCStrong' id='languageStringTextTOCStrong'>TOCStrong</span>




















  <span class='languageStringText' i18n='@@Top' id='languageStringTextTop'>Top</span>













  <span class='languageStringText' i18n='@@Tracking Numbers' id='languageStringTextTrackingNumbers'>Tracking Numbers</span>
  <span class='languageStringText' i18n='@@Traditional' id='languageStringTextTraditional'>Traditional</span>









  <span class='languageStringText' i18n='@@Trim' id='languageStringTextTrim'>Trim</span>


  <span class='languageStringText' i18n='@@TrippleNestedListItem' id='languageStringTextTrippleNestedListItem'>TrippleNestedListItem</span>





  <span class='languageStringText' i18n='@@Type' id='languageStringTextType'>Type</span>

  <span class='languageStringText' i18n='@@Ubuntu' id='languageStringTextUbuntu'>Ubuntu</span>
  <span class='languageStringText' i18n='@@UbuntuCondensed' id='languageStringTextUbuntuCondensed'>UbuntuCondensed</span>


  <span class='languageStringText' i18n='@@Umbrella' id='languageStringTextUmbrella'>Umbrella</span>
  <span class='languageStringText' i18n='@@Umbrella Name' id='languageStringTextUmbrellaName'>Umbrella Name</span>












  <span class='languageStringText' i18n='@@Unknown' id='languageStringTextUnknown'>Unknown</span>
  <span class='languageStringText' i18n='@@UnknownStatus' id='languageStringTextUnknownStatus'>UnknownStatus</span>








  <span class='languageStringText' i18n='@@Unsupported file type. Use PNG, JPEG, GIF, or PDF.' id='languageStringTextUnsupportedfiletype.UsePNG,JPEG,GIF,orPDF.'>Unsupported file type. Use PNG, JPEG, GIF, or PDF.</span>

  <span class='languageStringText' i18n='@@UPDATE' id='languageStringTextUPDATE'>Update</span>





















  <span class='languageStringText' i18n='@@upper-alpha' id='languageStringTextupper-alpha'>upper-alpha</span>
  <span class='languageStringText' i18n='@@upper-greek' id='languageStringTextupper-greek'>upper-greek</span>
  <span class='languageStringText' i18n='@@upper-latin' id='languageStringTextupper-latin'>upper-latin</span>
  <span class='languageStringText' i18n='@@upper-roman' id='languageStringTextupper-roman'>upper-roman</span>





























  <span class='languageStringText' i18n='@@USER' id='languageStringTextUSER'>User</span>

  <span class='languageStringText' i18n='@@User Id' id='languageStringTextUserId'>User Id</span>

  <span class='languageStringText' i18n='@@User Person' id='languageStringTextUserPerson'>User Person</span>
  <span class='languageStringText' i18n='@@User Status' id='languageStringTextUserStatus'>User Status</span>
  <span class='languageStringText' i18n='@@User Type' id='languageStringTextUserType'>User Type</span>























  <span class='languageStringText' i18n='@@VALID_ASSIGN_FACILITY' id='languageStringTextVALID_ASSIGN_FACILITY'>VALID_ASSIGN_FACILITY</span>
  <span class='languageStringText' i18n='@@VALID_COMPUTE_PRODUCTION_COSTS' id='languageStringTextVALID_COMPUTE_PRODUCTION_COSTS'>VALID_COMPUTE_PRODUCTION_COSTS</span>
  <span class='languageStringText' i18n='@@VALID_COMPUTE_TAX' id='languageStringTextVALID_COMPUTE_TAX'>VALID_COMPUTE_TAX</span>
  <span class='languageStringText' i18n='@@VALID_CREATE_PACKAGES' id='languageStringTextVALID_CREATE_PACKAGES'>VALID_CREATE_PACKAGES</span>
  <span class='languageStringText' i18n='@@VALID_FUNCTIONAL_INPUTS' id='languageStringTextVALID_FUNCTIONAL_INPUTS'>VALID_FUNCTIONAL_INPUTS</span>
  <span class='languageStringText' i18n='@@VALID_RATE_SHIPPING' id='languageStringTextVALID_RATE_SHIPPING'>VALID_RATE_SHIPPING</span>
  <span class='languageStringText' i18n='@@VALID_RAW_ORDER' id='languageStringTextVALID_RAW_ORDER'>VALID_RAW_ORDER</span>








  <span class='languageStringText' i18n='@@Validation' id='languageStringTextValidation'>Validation</span>



  <span class='languageStringText' i18n='@@VarelaRound' id='languageStringTextVarelaRound'>VarelaRound</span>















  <span class='languageStringText' i18n='@@vs.' id='languageStringTextvs.'>vs.</span>
  <span class='languageStringText' i18n='@@vs. last save.' id='languageStringTextvs.lastsave.'>vs. last save.</span>
  <span class='languageStringText' i18n='@@W' id='languageStringTextW'>W</span>
  <span class='languageStringText' i18n='@@WAITING' id='languageStringTextWAITING'>Waiting</span>






  <span class='languageStringText' i18n='@@was 8' id='languageStringTextwas8'>was 8</span>

  <span class='languageStringText' i18n='@@Weight' id='languageStringTextWeight'>Weight</span>



  <span class='languageStringText' i18n='@@whole' id='languageStringTextwhole'>whole</span>
  <span class='languageStringText' i18n='@@whole-background' id='languageStringTextwhole-background'>whole-background</span>
  <span class='languageStringText' i18n='@@whole-background-image' id='languageStringTextwhole-background-image'>whole-background-image</span>
  <span class='languageStringText' i18n='@@whole-hidden-image' id='languageStringTextwhole-hidden-image'>whole-hidden-image</span>
  <span class='languageStringText' i18n='@@whole-image-1' id='languageStringTextwhole-image-1'>whole-image-1</span>
  <span class='languageStringText' i18n='@@whole-image-2' id='languageStringTextwhole-image-2'>whole-image-2</span>
  <span class='languageStringText' i18n='@@whole-image-3' id='languageStringTextwhole-image-3'>whole-image-3</span>
  <span class='languageStringText' i18n='@@whole-line-1' id='languageStringTextwhole-line-1'>whole-line-1</span>
  <span class='languageStringText' i18n='@@whole-line-2' id='languageStringTextwhole-line-2'>whole-line-2</span>
  <span class='languageStringText' i18n='@@whole-rectangle-1' id='languageStringTextwhole-rectangle-1'>whole-rectangle-1</span>
  <span class='languageStringText' i18n='@@whole-rectangle-2' id='languageStringTextwhole-rectangle-2'>whole-rectangle-2</span>
  <span class='languageStringText' i18n='@@whole-rectangle-3' id='languageStringTextwhole-rectangle-3'>whole-rectangle-3</span>
  <span class='languageStringText' i18n='@@wholeBack' id='languageStringTextwholeBack'>wholeBack</span>
  <span class='languageStringText' i18n='@@wholeBack2' id='languageStringTextwholeBack2'>wholeBack2</span>
  <span class='languageStringText' i18n='@@wholeBack3' id='languageStringTextwholeBack3'>wholeBack3</span>
  <span class='languageStringText' i18n='@@wholeLine' id='languageStringTextwholeLine'>wholeLine</span>
  <span class='languageStringText' i18n='@@wholesale' id='languageStringTextwholesale'>Wholesale</span>

  <span class='languageStringText' i18n='@@width' id='languageStringTextwidth'>width</span>
  <span class='languageStringText' i18n='@@Width' id='languageStringTextWidth'>Width</span>

  <span class='languageStringText' i18n='@@WOOCOMMERCE' id='languageStringTextWOOCOMMERCE'>WOOCOMMERCE</span>
















  <span class='languageStringText' i18n='@@Your certificate is accepted as reciprocal evidence here.' id='languageStringTextYourcertificateisacceptedasreciprocalevidencehere.'>Your certificate is accepted as reciprocal evidence here.</span>












  <span class='languageStringText' i18n='@@YourSessionHasTimedOut.PleaseLoginAgain.' id='languageStringTextYourSessionHasTimedOut.PleaseLoginAgain.'>YourSessionHasTimedOut.PleaseLoginAgain.</span>
  <span class='languageStringText' i18n='@@Yrsa' id='languageStringTextYrsa'>Yrsa</span>


  <span class='languageStringText' i18n='@@ZillaSlab' id='languageStringTextZillaSlab'>ZillaSlab</span>

  <span class='languageStringText' i18n='@@Zip' id='languageStringTextZip'>Zip</span>









  <!-- Recovered LanguagePipe registry entries — see tools/reconcile-language-registry.js -->
  <span class='languageStringText' i18n='@@The Project could not be moved.' id='languageStringTextTheProjectcouldnotbemoved.'>The Project could not be moved.</span>
  <span class='languageStringText' i18n='@@Some Projects could not be moved.' id='languageStringTextSomeProjectscouldnotbemoved.'>Some Projects could not be moved.</span>
  <span class='languageStringText' i18n='@@Moving a Project to or from My Projects is temporarily unavailable.' id='languageStringTextMovingaProjecttoorfromMyProjectsistemporarilyunavailable.'>Moving a Project to or from My Projects is temporarily unavailable.</span>
  <span class='languageStringText' i18n='@@Administrative privileges granted' id='languageStringTextAdministrativeprivilegesgranted'>Administrative privileges granted</span>
  <span class='languageStringText' i18n='@@Administrative privileges revoked' id='languageStringTextAdministrativeprivilegesrevoked'>Administrative privileges revoked</span>
  <span class='languageStringText' i18n='@@Could not grant administrative privileges. The user does not have them.' id='languageStringTextCouldnotgrantadministrativeprivileges.Theuserdoesnothavethem.'>Could not grant administrative privileges. The user does not have them.</span>
  <span class='languageStringText' i18n='@@Could not revoke administrative privileges. The user still has them.' id='languageStringTextCouldnotrevokeadministrativeprivileges.Theuserstillhasthem.'>Could not revoke administrative privileges. The user still has them.</span>
  <span class='languageStringText' i18n='@@Privileges granted' id='languageStringTextPrivilegesgranted'>Privileges granted</span>
  <span class='languageStringText' i18n='@@Privileges revoked' id='languageStringTextPrivilegesrevoked'>Privileges revoked</span>
  <span class='languageStringText' i18n='@@Could not grant the privilege. The user does not have it.' id='languageStringTextCouldnotgranttheprivilege.Theuserdoesnothaveit.'>Could not grant the privilege. The user does not have it.</span>
  <span class='languageStringText' i18n='@@Could not revoke the privilege. The user still has it.' id='languageStringTextCouldnotrevoketheprivilege.Theuserstillhasit.'>Could not revoke the privilege. The user still has it.</span>
  <span class='languageStringText' i18n='@@User added' id='languageStringTextUseradded'>User added</span>
  <span class='languageStringText' i18n='@@Could not add the user. No invitation has been sent.' id='languageStringTextCouldnotaddtheuser.Noinvitationhasbeensent.'>Could not add the user. No invitation has been sent.</span>
  <span class='languageStringText' i18n='@@User disabled' id='languageStringTextUserdisabled'>User disabled</span>
  <span class='languageStringText' i18n='@@User enabled' id='languageStringTextUserenabled'>User enabled</span>
  <span class='languageStringText' i18n='@@Could not disable the user. They still have access.' id='languageStringTextCouldnotdisabletheuser.Theystillhaveaccess.'>Could not disable the user. They still have access.</span>
  <span class='languageStringText' i18n='@@Could not enable the user.' id='languageStringTextCouldnotenabletheuser.'>Could not enable the user.</span>
  <span class='languageStringText' i18n='@@Invitation sent' id='languageStringTextInvitationsent'>Invitation sent</span>
  <span class='languageStringText' i18n='@@Could not resend the invitation.' id='languageStringTextCouldnotresendtheinvitation.'>Could not resend the invitation.</span>
  <span class='languageStringText' i18n='@@Could not load the user.' id='languageStringTextCouldnotloadtheuser.'>Could not load the user.</span>
  <span class='languageStringText' i18n='@@Your account was created, but the setup behind it did not finish. Please sign in - signing in again will often complete it. If it does not, contact us and let us know you have already created an account, and a system administrator will fix it.' id='languageStringTextYouraccountwascreatedbutthesetupbehinditdidnotfinish.Pleasesigninsigninginagainwilloftencompleteit.Ifitdoesnotcontactusandletusknowyouhavealreadycreatedanaccountandasystemadministratorwillfixit.'>Your account was created, but the setup behind it did not finish. Please sign in - signing in again will often complete it. If it does not, contact us and let us know you have already created an account, and a system administrator will fix it.</span>
  <span class='languageStringText' i18n='@@The order could not be created.' id='languageStringTextTheordercouldnotbecreated.'>The order could not be created.</span>
  <span class='languageStringText' i18n='@@Replenishment order placed.' id='languageStringTextReplenishmentorderplaced.'>Replenishment order placed.</span>
  <span class='languageStringText' i18n='@@The replenishment order could not be placed.' id='languageStringTextThereplenishmentordercouldnotbeplaced.'>The replenishment order could not be placed.</span>
  <span class='languageStringText' i18n='@@Archived' id='languageStringTextArchived'>Archived</span>
  <span class='languageStringText' i18n='@@Create Project failed. Please try again.' id='languageStringTextCreateProjectfailed.Pleasetryagain.'>Create Project failed. Please try again.</span>
  <span class='languageStringText' i18n='@@Draft added' id='languageStringTextDraftadded'>Draft added</span>
  <span class='languageStringText' i18n='@@The Book could not be moved.' id='languageStringTextTheBookcouldnotbemoved.'>The Book could not be moved.</span>
  <span class='languageStringText' i18n='@@The Draft could not be created.' id='languageStringTextTheDraftcouldnotbecreated.'>The Draft could not be created.</span>
  <span class='languageStringText' i18n='@@The Draft could not be moved.' id='languageStringTextTheDraftcouldnotbemoved.'>The Draft could not be moved.</span>
  <span class='languageStringText' i18n='@@The server would not accept the file for this organization.' id='languageStringTextTheserverwouldnotacceptthefileforthisorganization.'>The server would not accept the file for this organization.</span>
  <span class='languageStringText' i18n='@@This Draft is still loading. Please try again in a moment.' id='languageStringTextThisDraftisstillloading.Pleasetryagaininamoment.'>This Draft is still loading. Please try again in a moment.</span>
  <span class='languageStringText' i18n='@@My Projects' id='languageStringTextMyProjects'>My Projects</span>
  <span class='languageStringText' i18n='@@Fulfill From Inventory' id='languageStringTextFulfillFromInventory'>Fulfill From Inventory</span>
  <span class='languageStringText' i18n='@@Print To Order' id='languageStringTextPrintToOrder'>Print To Order</span>
  <span class='languageStringText' i18n='@@Replenish Inventory' id='languageStringTextReplenishInventory'>Replenish Inventory</span>
  <span class='languageStringText' i18n='@@Mixed' id='languageStringTextMixed'>Mixed</span>
  <span class='languageStringText' i18n='@@Inventory Type Has Not Been Set For This Item' id='languageStringTextInventoryTypeHasNotBeenSetForThisItem'>Inventory Type Has Not Been Set For This Item</span>
  <span class='languageStringText' i18n='@@Item Inventory Type Does Not Match Its Set' id='languageStringTextItemInventoryTypeDoesNotMatchItsSet'>Item Inventory Type Does Not Match Its Set</span>
  <span class='languageStringText' i18n='@@Items With A Different Inventory Type Than This Set' id='languageStringTextItemsWithADifferentInventoryTypeThanThisSet'>Items With A Different Inventory Type Than This Set</span>
  <span class='languageStringText' i18n='@@Set Inventory Type Does Not Match Its Bucket Period' id='languageStringTextSetInventoryTypeDoesNotMatchItsBucketPeriod'>Set Inventory Type Does Not Match Its Bucket Period</span>
  <span class='languageStringText' i18n='@@No' id='languageStringTextNo'>No</span>
  <span class='languageStringText' i18n='@@Yes' id='languageStringTextYes'>Yes</span>
  <span class='languageStringText' i18n='@@Go Back' id='languageStringTextGoBack'>Go Back</span>
  <span class='languageStringText' i18n='@@Cancel' id='languageStringTextCancel'>Cancel</span>
  <span class='languageStringText' i18n='@@You are still editing this order. Going back now will discard the changes you have not saved.' id='languageStringTextYouarestilleditingthisorder.Goingbacknowwilldiscardthechangesyouhavenotsaved.'>You are still editing this order. Going back now will discard the changes you have not saved.</span>

  <!-- ════════════════════════════════════════════════════════════════
       PROJECT MAPPING - failure sentences
       Read at runtime by ProjectMappingDashboardComponent and
       ProjectMappingReviewComponent via LanguagePipe.get(), as the
       fallback passed to ServerErrorToastService.reportError(). They
       are only shown when the server sent no prose of its own.
       Each one states what did NOT happen, because the whole point of
       moving these off the alert banner is that an operator should
       never be left guessing whether a mapping run started.
       ════════════════════════════════════════════════════════════ -->
  <span class='languageStringText' i18n='@@The mapping plan could not be started. Nothing has been changed.' id='languageStringTextThemappingplancouldnotbestarted.Nothinghasbeenchanged.'>The mapping plan could not be started. Nothing has been changed.</span>
  <span class='languageStringText' i18n='@@The mapping could not be applied. Nothing has been created.' id='languageStringTextThemappingcouldnotbeapplied.Nothinghasbeencreated.'>The mapping could not be applied. Nothing has been created.</span>
  <span class='languageStringText' i18n='@@Your answer could not be saved. Nothing has been changed.' id='languageStringTextYouranswercouldnotbesaved.Nothinghasbeenchanged.'>Your answer could not be saved. Nothing has been changed.</span>
  <span class='languageStringText' i18n='@@The run could not be reverted. Nothing has been changed.' id='languageStringTextTheruncouldnotbereverted.Nothinghasbeenchanged.'>The run could not be reverted. Nothing has been changed.</span>
  <!-- Not a failure: the route is not registered on this server yet. Said
       instead of the three sentences above, never alongside them - see
       component/project-mapping/mapping-write-unavailable.ts. Worded without
       naming the action, because it is shown for decide, apply AND revert. -->
  <span class='languageStringText' i18n='@@This is not available yet. Nothing has been changed.' id='languageStringTextThisisnotavailableyet.Nothinghasbeenchanged.'>This is not available yet. Nothing has been changed.</span>
  <!-- §3.4 records what it understands and returns the rest in rejected[].
       UNKNOWN_PROPOSAL means the plan was regenerated under the reader, so
       this says what to do rather than what went wrong - nothing did. -->
  <span class='languageStringText' i18n='@@This group is no longer part of the current plan. Refresh the page to see the current groupings.' id='languageStringTextThisgroupisnolongerpartofthecurrentplan.Refreshthepagetoseethecurrentgroupings.'>This group is no longer part of the current plan. Refresh the page to see the current groupings.</span>

  <!-- ════════════════════════════════════════════════════════════
       PROJECT MAPPING - dashboard row titles
       Read at runtime by ProjectMappingDashboardComponent.rowTitle()
       via LanguagePipe.get(). One row element cannot carry three
       alternative i18n-title attributes, and the three cases are the
       point: a row either opens a plan, is building one, or has none
       yet and will start one when clicked.
       ════════════════════════════════════════════════════════════ -->
  <span class='languageStringText' i18n='@@Open this organization to review its proposed groupings.' id='languageStringTextOpenthisorganizationtoreviewitsproposedgroupings.'>Open this organization to review its proposed groupings.</span>
  <span class='languageStringText' i18n='@@Working out the proposed groupings. This organization can be opened once the plan is ready.' id='languageStringTextWorkingouttheproposedgroupings.Thisorganizationcanbeopenedoncetheplanisready.'>Working out the proposed groupings. This organization can be opened once the plan is ready.</span>
  <span class='languageStringText' i18n='@@This organization has not been planned yet. Select it to work out the proposed groupings. Nothing is created.' id='languageStringTextThisorganizationhasnotbeenplannedyet.Selectittoworkouttheproposedgroupings.Nothingiscreated.'>This organization has not been planned yet. Select it to work out the proposed groupings. Nothing is created.</span>
  <span class='languageStringText' i18n='@@Open this organization. It has not been planned yet, and the page will offer to plan it.' id='languageStringTextOpenthisorganization.Ithasnotbeenplannedyet,andthepagewillofferttoplanit.'>Open this organization. It has not been planned yet, and the page will offer to plan it.</span>
</div>
